import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  DoCheck,
  ElementRef,
  Input,
  NgZone,
  OnInit,
  Renderer2,
  TemplateRef,
  ViewChild,
  ViewChildren,
  QueryList,
} from '@angular/core';
import { AbstractControl, UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators ,UntypedFormControl} from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Store, select } from '@ngrx/store';
import { Subject, combineLatest, of } from 'rxjs';
import {
  debounceTime,
  distinctUntilChanged,
  filter,
  map,
  take,
} from 'rxjs/operators';
import { ActionService, Extra } from 'src/app/core/services/action.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { CommonService } from 'src/app/core/services/common.service';
import { ReportRecordService } from 'src/app/core/services/report-record.service';
import { RouteService } from 'src/app/core/services/route.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { LoadApplication } from 'src/app/core/state/_actions/application.actions';
import { LoadFields } from 'src/app/core/state/_actions/field.actions';
import {
  CopyData,
  GetRelatedData,
  GetSVGData,
  LoadFormData,
  LoadFormID,
  LoadFormRules,
  LoadFormSavedFields,
  PostData, PutData, ResetFormRule, ResetRelatedData
} from 'src/app/core/state/_actions/form.actions';
import {
  LoadDetails
} from 'src/app/core/state/_actions/report.actions';
import {
  Column,
  FormDataField,
  SavedFields,
  TabData,
} from 'src/app/core/state/_models/form.model';
import { OpTypes } from 'src/app/core/state/_models/general.model';
import { getApplicationData } from 'src/app/core/state/_selectors/application.selector';
import { getFields } from 'src/app/core/state/_selectors/field.selector';
import {
  getError,
  getFormData,
  getFormIDs,
  getFormOperations,
  getSVGData,
  getformRules,
  getformSavedfields
} from 'src/app/core/state/_selectors/form.selector';
import {
  getReportDetails,
  getReportOperations
} from 'src/app/core/state/_selectors/report.selector';
import { getUserProfile } from 'src/app/core/state/_selectors/user.selector';
import { DocEditorService } from 'src/app/core/state/_services/doc-editor.service';
import { FormService } from 'src/app/core/state/_services/form.service';
import { fileToBase64 } from 'src/app/core/utils/data-processor.util';
import { ViewComponent as AddTemplate } from 'src/app/shared/components/templates/view/view.component';
import {
  DATE_PATTERN_MM_DD_YYYY,
  DATE_PATTERN_MM_DD_YYYY_TIME,
  DATE_PATTERN_MM_DD_YYYY_TIME_HOUR,
  DATE_PATTERN_YYYY_MM_DD,
  DATE_PATTERN_YYYY_MM_DD_TIME,
  DROPDOWN_VALUE_PLACEHOLDER,
  EMAIL_PATTERN,
  UUID_PATTERN
} from 'src/app/shared/constants';
import {
  AlertService,
  ToastTypes,
  alertPresets,
} from 'src/app/shared/services/alert.service';
import { noOnlySpacesValidator } from 'src/app/shared/validators/no-space.validator';
import { SubSink } from 'subsink';
import { SweetAlertOptions } from 'sweetalert2';
import { createdbyRegex, datecreatedRegex, datemodifiedRegex, modifiedbyRegex } from '../../../../../../shared/components/datatable/datatable.constants';
import { RecordCommonTemplatesComponent } from '../record-common-templates/record-common-templates.component';
import * as moment from 'moment';
import { LaunchDarklyService } from 'src/app/core/services/launchdarkly.service';
import { FEATURE_FLAGS } from 'src/app/shared/launchdarkly.constants';
import { ChildTableEmbeddedComponent } from 'src/app/shared/components/child-table/child-table-embedded.component';
import { FileMissingTooltipHelper } from 'src/app/shared/helpers/file-missing-tooltip.helper';


@Component({
  selector: 'app-actions',
  templateUrl: './actions.component.html',
  styleUrls: ['./actions.component.scss'],
  host:{ class: 'content-fit-table-parent'}
})
export class ActionsComponent implements OnInit, DoCheck, AfterViewInit {
  private readonly subscribers = new SubSink();
  private reloadableSubscribers = new SubSink(); // Subscriptions that get recreated on save
  @ViewChild('input', { static: false }) input!: TemplateRef<any>;
  @ViewChild('select', { static: false }) select!: TemplateRef<any>;
  @ViewChild('select2', { static: false }) select2!: TemplateRef<any>;
  @ViewChild('selectSearchScroll', { static: false })
  selectSearchScroll!: TemplateRef<any>;
  @ViewChild('checkbox', { static: false }) checkbox!: TemplateRef<any>;
  @ViewChild('textarea', { static: false }) textarea!: TemplateRef<any>;
  @ViewChild('file', { static: false }) file!: TemplateRef<any>;
  @ViewChild('html', { static: false }) html!: TemplateRef<any>;
  @ViewChild('report', { static: false }) report!: TemplateRef<any>;
  @ViewChild('childTable', { static: false }) childTable!: TemplateRef<any>;
  @ViewChild('button', { static: false }) button!: TemplateRef<any>;
  @ViewChild('header', { static: false }) header!: TemplateRef<any>;
  @ViewChild('divider', { static: false }) divider!: TemplateRef<any>;
  @ViewChild('collapse', { static: false }) collapse!: TemplateRef<any>;
  @ViewChild('urlReadonly', { static: false }) urlReadonly!: TemplateRef<any>;
  @ViewChild(RecordCommonTemplatesComponent, { static: false })
  recordCommonTemplates!: RecordCommonTemplatesComponent;
  @ViewChildren(ChildTableEmbeddedComponent)
  childTableComponents!: QueryList<ChildTableEmbeddedComponent>;
  localDateFormat:string = '';
  localDatetimeFormat:string = '';
  private readonly excludeFields = [
    'Date Modified',
    'Date Created',
    'Modified By',
    'Created By',
    'Record Id',
  ];

  private readonly actionButtons = [
    'Next',
    'Cancel',
    'Previous',
    'SaveAndExit',
    'SaveAndContinue',
  ];

  private _recordId: any = '';

  form!: UntypedFormGroup;
  savedFields: SavedFields = {
    HeaderFields: [],
    TabData: [],
    FormRules: [],
    HasCustomButtons: false,
  };
  applicationTableAllFields: Array<any> = [];
  completeTableFields: Array<any> = []; // Complete field metadata from store with FieldType
  fieldsToBeAdded: Array<any> = [];
  buttonReferencedFieldsAdded: Array<any> = []; // Track fields added for button actions
  valueChangedFields: Array<any> = [];
  rowColMap: Array<Array<Array<Column>>> = [];
  headerRowMap: Array<Array<Column>> = [];
  footerRowMap: Array<Array<Column>> = [];
  userFieldOptions: Array<any> = [];
  userOptions: Array<any> = [];
  userRole: string = '';
  currentUserEmail: string = '';
  readonlyFieldsValue: any = {};
  tabIndex: number = 0;
  allowClose: boolean = true;
  isActionBtnActive: boolean = false;
  isCustomBtnActive: boolean = false;
  routeTableKey: string = '';
  reportDetails: any = null;
  relationTabs: any = null;
  trigger = new Subject<boolean>();
  currentRelationTab: number = 0;
  columnToDelete: any;
  formRules: any;
  buttonShowArray: any = [];
  buttonHideArray: any = [];
  styleOptionShowArray: any = [];
  styleOptionHideArray: any = [];
  buttonDisabled: any = [];
  colHideArr: any = [];
  colRequireArr: any = [];
  colReadOnlyArr: any = [];
  colShowArr: any = [];
  displayMessages: any = {};
  tabSpecificMessages: any = {};
  isApplyRuleCalled: boolean = false;
  shouldReapplyRulesAfterSave: boolean = false; // Trigger rules re-evaluation after save operations
  saveDisabled: boolean = false;
  isSaveContinueClicked:boolean = false;
  ruleFields: any = [];
  ruleIndexArr: any = [];
  preventSaveRules: Set<number> = new Set(); // Track rules with active PreventSave
  embeddedTableKey: any;
  embeddedReportKey: any;
  layeredModal!: NgbModalRef;
  buttonIcons: any = {};
  buttonIconNames: any = {};
  isButtonClicked: boolean = false;
  changeValuePerformed: any = [];
  fieldValueChange: any = [];
  currentTabIndex: any = 0;
  isValueAdded: boolean = false;
  isChatWidget: boolean = false;
  isPrintingForm: boolean = false;
  tabRowCollapsedArray: any = [];
  headerRowCollapsedArray: any = [];
  collapsedFieldArray: any = [];
  preventFilter: boolean = false;
  isColumnDropdownValueUpdated: boolean = false;
  defaultExtra: Extra = {
    success: {
      show: false,
      message: '',
      title: '',
      showSwal: false,
      alertOptions: <SweetAlertOptions>alertPresets.saveSuccess,
    },
    error: {
      show: false,
      title: '',
      showResponseError: false, // show error comming in response
    },
  };
  columnDataList: any = {};
  defaultFileFields: Array<Column> = []
  modalRefs:{ [key: string]: NgbModalRef } = {};
  tabDataFieldsMap: { [key: string]: Column } = {};

  @Input('relatedTableKey') relatedTableKey: string = '';
  @Input('relatedFormKey') relatedFormKey: string = '';
  @Input('modalLayer') modalLayer: number = 0;
  @Input('relatedParentValue') relatedParentValue: any = '';
  @Input('referenceFieldKey') referenceFieldKey: string = '';
  @Input('isInModal') isInModal: boolean = false;
  @Input('reportName') reportName: string = '';
  @Input('modalRecordId') modalRecordId: string = '';
  @Input('isRelatedOptionAdding') isRelatedOptionAdding: boolean = false;
  tableKeyOptions: any = [];
  relatedSingularNames: any = {};
  relatedOptions: any = {};
  isInProcess:boolean = false;
  processFormKey:string = '';
  fileFields:any[] = [];
  templateFiles:any[] = [];
  isRecordSaved: boolean = false;
  initialLoad:boolean=false;
  isActionOpened:boolean = false;
  isFormSubmittedOnce: boolean = false;
  isFormInitialized: boolean = false;
  // GABSW-1702: Remove this default once LaunchDarkly flag 'product-gab-ui-child-table' is fully rolled out.
  // Default to false so the old embedded report datatable is used until the feature flag is enabled.
  childTableEnabled: boolean = false;
  controlMap = new Map<string, AbstractControl>();
  fieldKeyMap = new Map<string, number>();
  private formGroupCache = new Map<string, UntypedFormGroup>();
  private preserveFormOnEmbeddedTableSave: boolean = false; // GABSW-2137 feature flag
  enableCustomButtonDisabled: boolean = false; // GABSW-1894 Feature flag to enable/disable custom buttons based on form validity
  isModalOverflowFixEnabled: boolean = false;
  resetSubmittingToken: number = 0;
  isFileMissingTooltipEnabled: boolean = false;
  fileMissingTooltip!: FileMissingTooltipHelper;
  isNewFormCollapsibleEnabled: boolean = false;
  enableAccessibleFormTabs: boolean = false;
  enableFormDropdownNgSelectValue: boolean = false;
  isA11yFileInputEnabled: boolean = false;
  private readonly uuidValidator = Validators.pattern(UUID_PATTERN);

  constructor(
    private readonly store: Store,
    private readonly action: ActionService,
    public route: RouteService,
    private readonly fb: UntypedFormBuilder,
    private readonly alert: AlertService,
    private readonly modal: NgbModal,
    private readonly authService: AuthService,
    private readonly cdr: ChangeDetectorRef,
    public commonService: CommonService,
    private renderer: Renderer2,
    private el: ElementRef,
    private readonly storageService:StorageService,
    private readonly docEditorService:DocEditorService,
    private readonly formService:FormService,
    public reportRecordService:ReportRecordService,
    private ngZone: NgZone,
    private readonly ldService: LaunchDarklyService,
  ) {
    this.fileMissingTooltip = new FileMissingTooltipHelper(this.cdr, this.el);
  }

  ngOnInit(): void {
    this.commonService.initializeActionColumn(170)
    this.routeTableKey = this.route.getTableKey();
    this.subscribers.add(
      this.ldService.getFlagValue(FEATURE_FLAGS.ENABLE_CHILD_TABLE, false).subscribe(
        (value) => { this.childTableEnabled = !!value; }
      )
    );

    this.subscribers.add(
      this.ldService.getFlagValue(FEATURE_FLAGS.ENABLE_CUSTOM_BUTTON_DISABLED, false)
        .subscribe((value) => { this.enableCustomButtonDisabled = !!value; })
    );
    // Subscribe to feature flag for GABSW-2137
    this.subscribers.add(
      this.ldService.getFlagValue(FEATURE_FLAGS.PRESERVE_FORM_ON_EMBEDDED_TABLE_SAVE, false)
        .subscribe((value) => { this.preserveFormOnEmbeddedTableSave = !!value; })
    );
    this.subscribers.add(
      this.ldService.getFlagValue(FEATURE_FLAGS.ENABLE_MODAL_OVERFLOW_FIX, false)
        .subscribe((value) => { this.isModalOverflowFixEnabled = !!value; })
    );
    this.subscribers.add(
      this.ldService.getFlagValue(FEATURE_FLAGS.ENABLE_FILE_MISSING_TOOLTIP, false)
        .subscribe((value) => { this.isFileMissingTooltipEnabled = !!value; })
    );
    this.subscribers.add(
      this.ldService.getFlagValue(FEATURE_FLAGS.ENABLE_NEW_FORM_COLLAPSIBLE, false)
        .subscribe((value) => { this.isNewFormCollapsibleEnabled = !!value; })
    );
    this.subscribers.add(
      this.ldService.getFlagValue(FEATURE_FLAGS.ENABLE_ACCESSIBLE_FORM_TABS, false)
        .subscribe((value) => { this.enableAccessibleFormTabs = !!value; })
    );
    this.subscribers.add(
      this.ldService.getFlagValue(FEATURE_FLAGS.ENABLE_FORM_DROPDOWN_NG_SELECT, false)
        .subscribe((value) => { this.enableFormDropdownNgSelectValue = !!value; })
    );
    this.subscribers.add(
      this.ldService.getFlagValue(FEATURE_FLAGS.ENABLE_A11Y_FILE_INPUT, false)
        .subscribe((value) => { this.isA11yFileInputEnabled = !!value; })
    );
    this.subscribers.sink = this.route.fork(this.routeChange.bind(null));
    this.subscribers.add(
      this.commonService.printForm.subscribe(() => {
        this.isPrintingForm = true;
        this.cdr.detectChanges();
    }));
    // Listen for form changes to re-enable save if needed
    this.subscribers.add(
      this.trigger.asObservable().subscribe(() => {
        // Only reset saveDisabled if no rules with PreventSave are active
        if (this.preventSaveRules.size === 0) {
          this.saveDisabled = false;
        }
        this.cdr.detectChanges();
      })
    );
  }

  routeChange = () => {
    this.form = this.fb.group({});
    this.formGroupCache.clear();
    this.controlMap.clear();
    this.fieldKeyMap.clear();
    this.relatedOptions = {};
    this.store.dispatch(new ResetRelatedData());
    this.tabIndex = 0;
    this.currentRelationTab = 0;
    this.currentTabIndex = 0;
    this.rowColMap = [];
    this.headerRowMap = [];
    this.footerRowMap = [];
    this.isValueAdded = false;
    this.relationTabs = [];
    this.isColumnDropdownValueUpdated = false;
    this.isApplyRuleCalled = false;
    this.shouldReapplyRulesAfterSave = false;
    this.saveDisabled = false;
    this.preventSaveRules.clear(); // Reset PreventSave tracking
    this.isActionBtnActive = false;
    this.isFormInitialized = false; // Reset so form can be initialized for new route
    this.init();
  }

  ngDoCheck() {
    if (this.isPrintingForm) {
      let mediaMatchList = window.matchMedia('print');
      if (!mediaMatchList.matches) {
        this.isPrintingForm = false;
        this.cdr.detectChanges();
      }
    } else {
      let mediaMatchList = window.matchMedia('print');
      if (mediaMatchList.matches) {
        this.isPrintingForm = true;
        this.cdr.detectChanges();
      }
    }
  }

  ngAfterViewInit() {
    this.init();
    this.cdr.detectChanges();
  }

  init = () => {
    const tableKey = this.route.getTableKey();
    const appKey = this.route.getApplicationKey();
    const { id, reportId } = this.route.paramMap ?? {};

    this.detectLocalFormats();

    // Dispatch form ID load
    this.store.dispatch(new LoadFormID(tableKey, reportId));

    // Storage values
    this.isInProcess = !!this.storageService.getIsEditInProcess(this.reportId);
    this.processFormKey = this.storageService.getEditProcessKey(this.reportId) || '';

    this.allowClose = false;

    // Related keys setup
    this.isFormSubmittedOnce = false;
    if (this.routeTableKey && this.routeTableKey === tableKey) {
      this.relatedTableKey = this.relatedTableKey || tableKey;
      this.relatedFormKey =
        (this.relatedFormKey && (this.isInModal || this.modalLayer))
          ? this.relatedFormKey
          : this.formId;
    } else {
      this.relatedTableKey = tableKey;
      this.relatedFormKey = this.formId;
      this.routeTableKey = tableKey;
    }

    // Application data subscription
    this.subscribers.sink = this.store
      .pipe(
        select(getApplicationData),
        filter((data) => !!data[appKey])
      )
      .subscribe((data) => {
        if (Object.keys(data).length) {
          this.tableKeyOptions = data[appKey].Tables.filter((t) => t.Name !== 'Audit Log');
        } else {
          this.store.dispatch(new LoadApplication(appKey));
        }
      });

    // Load complete field data from store for proper type mapping
    this.store.dispatch(new LoadFields(this.relatedTableKey));
    this.subscribers.sink = this.store
      .pipe(
        select(getFields),
        filter((fields) => !!fields[this.relatedTableKey])
      )
      .subscribe((fields) => {
        // Store complete field metadata for dynamic field creation
        this.completeTableFields = fields[this.relatedTableKey];
      });

    // Load saved fields + rules
    this.store.dispatch(
      new LoadFormSavedFields(
        this.relatedTableKey,
        this.relatedFormKey,
        true,
        !!this.relatedParentValue,
        this.relatedParentValue ? tableKey?.toString() : '0'
      )
    );
    this.store.dispatch(new LoadFormRules(this.relatedFormKey, this.relatedTableKey));

    // Record ID setup
    if (id) {
      this.recordId = this.isInModal ? this.modalRecordId : Number(id);
    }

    this.loadSubscribers();

    // Load data if update
    if (this.isUpdate) {
      this.store.dispatch(
        new LoadFormData(this.relatedTableKey, this.relatedFormKey, this.recordId)
      );
      if (!this.isInModal) {
        this.loadDetailRelations();
      }
    }

    // Load button icons
    if (Object.keys(this.buttonIconNames).length && !Object.keys(this.buttonIcons).length) {
      const icons = Object.keys(this.buttonIconNames).map((icon) => this.getIconName(icon));
      this.store.dispatch(new GetSVGData(icons));
    }
  };

  get reportId() {
    return this.route.paramMap.reportId;
  }

  get id() {
    return (this.isCopyRecord && this.isRecordSaved) ? this.recordId : ( this.route.paramMap.id || this.recordId);
  }

  get summaryfieldId() {
    return this.route.paramMap.summaryfieldId;
  }

  columnFilter = (col: Column) => {
    if (
      col.FieldName == 'datemodified' ||
      col.FieldName == 'datecreated' ||
      col.FieldName == 'createdby' ||
      col.FieldName == 'modifiedby'
    )
      return false;
    return (
      ((col.IsFormulaField === col.IsLookupField) === col.IsSummaryField) ===
      false
    );
  };
  initForm() {
    const fields: Column[] = [
      ...this.savedFields.TabData.reduce((acc: Column[], tab: TabData) => {
      return acc.concat(tab.Columns || []);
    }, []),
      ...this.savedFields.HeaderFields
    ];

    // Collect fields referenced by button FieldChangeValue actions
    const buttonReferencedFields = new Set<string>();
    [...this.savedFields.TabData, { Columns: this.savedFields.HeaderFields }].forEach((tab: any) => {
      tab.Columns?.forEach((col: Column) => {
        if (col.FormStyleOption?.FieldChangeValue?.length) {
          col.FormStyleOption.FieldChangeValue.forEach(fcv => {
            buttonReferencedFields.add(fcv.FieldKey);
          });
        }
      });
    });

    // Add fields that are referenced by buttons or needed for update mode
    if (Array.isArray(this.applicationTableAllFields) && this.applicationTableAllFields.length) {
      const existingKeys = new Set(fields.map(f => f.FieldKey));
      const keysToAdd = new Set<string>();

      // Add button-referenced fields that don't exist on the form
      buttonReferencedFields.forEach(key => {
        if (!existingKeys.has(key)) {
          keysToAdd.add(key);
        }
      });

      // In update mode, also add all table fields not on the form
      if (this.isUpdate) {
        this.applicationTableAllFields.forEach((f: any) => {
          if (!existingKeys.has(f.Key) && !keysToAdd.has(f.Key)) {
            keysToAdd.add(f.Key);
          }
        });
        // fieldsToBeAdded excludes button-referenced fields (they should be submitted)
        this.fieldsToBeAdded = Array.from(keysToAdd).filter(key => !buttonReferencedFields.has(key));
      } else {
        // In Add mode, track button-referenced fields that were added
        // These need to be excluded from payload once isUpdate becomes true
        this.buttonReferencedFieldsAdded = Array.from(buttonReferencedFields).filter(key => !existingKeys.has(key));
      }

      // Build and add the extra field controls
      const extraFields: Column[] = this.applicationTableAllFields
        .filter((f: any) => keysToAdd.has(f.Key))
        .map((f: any) => this.buildColumnFromApplicationField(f));
      fields.push(...extraFields);
    }

    // Precompute Hide Map for role-based validation
    const hideMap = new Map<number, { admin: boolean; participant: boolean }>();
    this.savedFields.TabData.forEach((tab, idx) => {
      hideMap.set(idx, { admin: tab.HideForAdmin, participant: tab.HideForParticipants });
    });

    // Create FormArray efficiently
    const UntypedFormArray = this.fb.array(fields.map(f => this.createFieldGroup(f, hideMap)));

    this.form = this.fb.group({
      ApplicationTableKey: [this.relatedTableKey],
      FieldsList: UntypedFormArray
    });

    // Initialize control maps for fast access
    this.initFieldKeyMap();

    // Spread fields for row/col mapping
    this.spreadFields();

    // Set form validations
    this.setFormValidations();

    // Subscribe to valueChanges with debounce
    this.reloadableSubscribers.add(
      this.form.valueChanges.pipe(debounceTime(300)).subscribe(() => {
        // Only reset saveDisabled if no rules with PreventSave are active
        if (this.saveDisabled && this.preventSaveRules.size === 0) {
          this.saveDisabled = false;
        }
        this.setFormValidations();
      })
    );

    this.cdr.detectChanges();
  }

  // ------------------- CREATE FORM GROUP -------------------
  private createFieldGroup(field: Column, hideMap: Map<number, { admin: boolean; participant: boolean }>): UntypedFormGroup {
    let arr = field.DropdownValues?.map((ddv:any) => ({ value: ddv.Value, label: ddv.Name })) ?? [];

    // USER field optimization
    if (field.DbFieldType === 'USER') {
      const currentUser = this.authService.userProfile.Email;
      arr = arr.filter((o:any) => o.value !== currentUser);
      arr.unshift({ value: currentUser, label: 'Current User' });
    }

    // ENUM fly addition
    if ((field.DbFieldType === 'ENUM' || field.DbFieldType === 'ENUM2') && this.isFormActionAllowed(field) && !this.isInModal) {
      arr.push({ value: 'click!', label: field.Name ? `<a>Add new ${field.Name}</a>` : `<a>Add Item</a>` });
    }

    const isRequired = this.userRole === 'super_admin' ||
      (this.userRole === 'admin' && !hideMap.get(field.TabIndex)?.admin) ||
      (this.userRole === 'participant' && !hideMap.get(field.TabIndex)?.participant);

    return this.fb.group({
      Name: [field.Name],
      Info: [field.Info],
      Value: [this.getInitialValue(field)],
      Type: [field.DbFieldType],
      Key: [field.FieldKey],
      DBName: [field.FieldName],
      DropdownValues: [arr],
      Base64EncodedFile: [field.DbFieldType === 'FILE' && field.FormFieldSetting?.DefaultFileData ? field.FormFieldSetting.DefaultFileData : ''],
      FileUrl: [field.FileUrl || this.fieldFileValue(field)],
      IsHeader: [field.IsHeader],
      FieldName: [field.FieldName],
      IsSent: [field.FormFieldSetting.IsSent],
      IsRichTextFormat: [field.FormFieldSetting.IsRichTextFormat],
      DropdownLabelKey: [field.DropdownLabelKey],
      DropdownLabelType: [field.DropdownLabelType],
      DecryptedValue: [this.fieldDecryptValue(field)],
      RelatedFieldValue:[''],
      IsFileMissing: [field.IsFileMissing ?? false]
    });
  }

  private buildColumnFromApplicationField(field: any): any {
    return {
      FieldKey: field.Key,
      Name: field.Name,
      Info: field.Info,
      DbFieldType: field.FieldType ?? field.DbName ?? '',
      ApplicationTableKey: field.ApplicationTableKey,
      FieldName: field.FieldName,
      IsFormulaField: field.IsFormulaField,
      IsHeader: field.IsHeader,
      IsHtmlAllowed: field.IsHtmlAllowed,
      IsHtml: field.IsHtml,
      IsNullable: field.isNullable,
      IsUnique: field.isUnique,
      FileUrl: field.FileUrl,
      FormFieldSetting: {
        IsFormFieldNameHidden: false,
        ESignEnabled: false,
        IsNameFieldChanged: false,
        OriginalNameValue: field.fieldName,
        FormFieldName: field.fieldName,
        ConditionGroup: [],
        Required: 0,
        Hidden: 0,
        Readonly: 0,
        RestrictChoices: false,
        DefaultValue: '',
        HasDefaultValue: false,
        MaintainLastValue: false,
        IsSent: field.IsSent,
        IsRichTextFormat: field.IsRichTextFormat
      },
      // Other properties defaulted
      GeneralType: '',
      DisplayRowIndex: 0,
      DisplayColumnIndex: 0,
      DecryptedValue: field.DecryptedValue,
      TabIndex: 0,
      Key: '',
      FormKey: '',
      FieldType: '',
      SchemaFormat: '',
      FormFormat: '',
      FormType: '',
      IsSummaryField: false,
      IsLookupField: false,
      IsUrlField: false,
      IsFlyAdditionAllowed: false,
      IsStyleOption: false,
      HasLinkText: false,
      IsExternalUrl: false,
    };
  }

  /**
   * Resolves applicationTableAllFields for Add mode when data[1] is not a valid array.
   * Prefers completeTableFields (has FieldType), falls back to tableKeyOptions.
   */
  private resolveApplicationTableFieldsForAddMode(): void {
    if (this.isUpdate || (Array.isArray(this.applicationTableAllFields) && this.applicationTableAllFields !== true as any)) {
      return;
    }

    // Prefer completeTableFields from getFields (has FieldType), fallback to tableKeyOptions
    if (Array.isArray(this.completeTableFields) && this.completeTableFields.length) {
      this.applicationTableAllFields = this.completeTableFields;
      return;
    }

    // tableKeyOptions is populated in init() from getApplicationData subscription
    const table = this.tableKeyOptions?.find((t: any) => t.Key === this.relatedTableKey);
    this.applicationTableAllFields = table?.Fields ?? [];
  }

  // ------------------- FIELD KEY MAP -------------------
  private initFieldKeyMap() {
    const fieldsArray = this.form.get('FieldsList') as UntypedFormArray;
    this.fieldKeyMap.clear();
    this.controlMap.clear();

    fieldsArray.controls.forEach((group, idx) => {
      const key = group.value.Key;
      const fieldName = group.value.FieldName;
      const valueControl = group.get('Value') ?? new UntypedFormControl('');

      // Add mapping by Key if it exists
      if (key && !this.fieldKeyMap.has(key)) {
        this.fieldKeyMap.set(key, idx);
        this.controlMap.set(key, valueControl);
      }

      // Also add mapping by FieldName if it exists and is different from Key
      if (fieldName && fieldName !== key && !this.controlMap.has(fieldName)) {
        this.fieldKeyMap.set(fieldName, idx);
        this.controlMap.set(fieldName, valueControl);
      }
    });
  }

  fieldIdToGroup(fieldKey: string): UntypedFormGroup | null {
    const idx = this.fieldKeyMap.get(fieldKey);
    return idx != null ? (this.form.get('FieldsList') as UntypedFormArray).at(idx) as UntypedFormGroup : null;
  }

  fieldIdToControl(fieldKey: string): AbstractControl {
    return this.controlMap.get(fieldKey) || new UntypedFormControl('');
  }

  // ------------------- SPREAD FIELDS -------------------
  spreadFields() {
    this.rowColMap = this.savedFields.TabData.map(tab => {
      const maxRow = Math.max(...tab.Columns.map(c => c.DisplayRowIndex), 0);
      return Array.from({ length: maxRow + 1 }, () => []);
    });

    this.footerRowMap = this.savedFields.TabData.map(tab => []);

    this.savedFields.TabData.forEach((tab, tabIndex) => {
      tab.Columns.forEach(col => {
        if (!col.EmbeddedSetting && (col as any).FormStyleOption?.FormField?.EmbeddedSetting) {
          col.EmbeddedSetting = (col as any).FormStyleOption.FormField.EmbeddedSetting;
        }
        this.rowColMap[tabIndex][col.DisplayRowIndex]?.push(col);
      });
      tab.Footer?.forEach(col => this.footerRowMap[tabIndex]?.push(col));
    });

    // Header fields
    const maxHeaderRow = Math.max(...this.savedFields.HeaderFields.map(c => c.DisplayRowIndex), 0);
    this.headerRowMap = Array.from({ length: maxHeaderRow + 1 }, () => []);
    this.savedFields.HeaderFields.forEach(col => this.headerRowMap[col.DisplayRowIndex]?.push(col));

    this.adjustHtmlFormWidth();
  }

  private adjustHtmlFormWidth() {
    const formId = 'form-add-update' + (this.isInModal ? '-in-modal' : '');
    const form = document.getElementById(formId);
    if (!form) return;

    const formWidth = form.offsetWidth;
    this.el.nativeElement.querySelectorAll('.custom-html-form').forEach((html: any) => {
      this.renderer.setStyle(html, 'max-width', `${formWidth}px`);
    });
  }

  // ------------------- GET INITIAL VALUE -------------------
  private getInitialValue(field: Column) {
    if (!this.isUpdate && field.FormFieldSetting.DefaultValue != null) {
      if (field.DbFieldType === 'TINYINT(1)') return field.FormFieldSetting.DefaultValue === '1';
      if (field.DbFieldType === 'ENUM2') return field.FormFieldSetting.DefaultValue.split(';');
      // For FILE fields with template defaults, use DefaultFileName instead of DefaultValue (template key)
      if (field.DbFieldType === 'FILE' && field.FormFieldSetting.DefaultFileName) {
        return field.FormFieldSetting.DefaultFileName;
      }
      return field.FormFieldSetting.DefaultValue;
    }

    if (field.FieldName === 'id') {
      if (this.isUpdate && !(this.relatedParentValue || (this.isCopyRecord && !this.isRecordSaved))) return this.recordId;
      if (this.relatedParentValue && this.isUpdate) return this.modalRecordId;
      return '';
    }

    if (field.FieldKey === this.referenceFieldKey) return this.relatedParentValue;
    return this.fieldValue(field);
  }

  setFormValidations(){
    if (this.savedFields.TabData.length > 1 && this.isActionBtnActive) {
      this.addFormValidators();
    } else if (
      this.savedFields.TabData.length == 1 ||
      !this.isActionBtnActive
    ) {
      this.setRequiredFields();
      this.setFieldsMaxLength();
    }
  }

  fieldValue = (col: any) => {
    if (!this.form) return null;
    if(
      (col.FieldName === 'datemodified' ||
      col.FieldName === 'datecreated' ||
      col.FieldName === 'createdby' ||
      col.FieldName === 'modifiedby') &&
      (!this.isCopyRecord || this.isRecordSaved)
    ){
      return '';
    }
    let fieldIndex = -1;
    if(col.IsStyleOption){
      fieldIndex = (
        this.form?.controls.FieldsList as UntypedFormArray
      )?.controls.findIndex(
        (group) =>
          group.value.Name === col.Name || group.value.FieldName === col.FieldName
      );
    } else {
      fieldIndex = (
        this.form?.controls.FieldsList as UntypedFormArray
      )?.controls.findIndex(
        (group) =>
          group.value.Key === col.FieldKey
      );
    }
    return (
      (this.form.controls.FieldsList as UntypedFormArray)?.at(fieldIndex) as UntypedFormGroup
    )?.controls?.Value?.value || (col.DbFieldType === 'USER' || col.IsRelation ? '' : null);
  };

  fieldFileValue = (col: any) => {
    if (!this.form) return '';
    const fieldIndex = (
      this.form?.controls.FieldsList as UntypedFormArray
    )?.controls.findIndex(
      (group) =>
        group.value.Key === col.FieldKey
    );
    return (
      (this.form?.controls?.FieldsList as UntypedFormArray)?.at(fieldIndex) as UntypedFormGroup
    )?.controls?.FileUrl?.value;
  };
  fieldDecryptValue = (col: any) => {
    if (!this.form) return '';
    const fieldIndex = (
      this.form?.controls.FieldsList as UntypedFormArray
    )?.controls.findIndex(
      (group) =>
        group.value.Key === col.FieldKey
    );
    return (
      (this.form?.controls?.FieldsList as UntypedFormArray)?.at(fieldIndex) as UntypedFormGroup
    )?.controls?.DecryptedValue?.value;
  };

  formGroupAt(col: Column): UntypedFormGroup {
    // Check cache first
    if (this.formGroupCache.has(col.FieldName)) {
      return this.formGroupCache.get(col.FieldName)!;
    }

    const fieldArray = this.form.controls.FieldsList as UntypedFormArray;
    const index = fieldArray.controls.findIndex(
      (group) => group.value?.FieldName === col.FieldName
    );

    const group = fieldArray.at(index) as UntypedFormGroup;

    // Cache it for future calls
    this.formGroupCache.set(col.FieldName, group);

    return group;
  }

  /**
   * Report id
   */
  get formId() {
    return this.route.paramMap.formId;
  }

  /**
   * Report id
   */
  get recordId() {
    return this._recordId || this.modalRecordId;
  }

  set recordId(value: any) {
    this._recordId = value;
  }

  /**
   * Is request to be updated
   */
  get isUpdate() {
    return (
      !!this.recordId &&
      (((this.referenceFieldKey === null || this.referenceFieldKey === '') &&
        this.relatedFormKey === this.formId &&
        this.relatedTableKey === this.route.getTableKey()) ||
        this.isInModal)
    );
  }
  get isCopyRecord() {
    return this.route.currentUrl.includes('/copy');
  }

  /**
   * Subscribers
   */
  loadSubscribers = () => {
    this.reloadableSubscribers.unsubscribe();
    this.reloadableSubscribers = new SubSink();

    this.reloadableSubscribers.add(
    this.store.pipe(select(getError)).subscribe((error: any) => {
      if (error != null && error.status >= 409) {
        this.alert.toast(ToastTypes.ERROR, error?.error?.Message, 'Error');
      }
    }));
    this.reloadableSubscribers.add(combineLatest([
      this.store.pipe(
        select(getformSavedfields),
        filter(
          (saved) =>
            !!saved[this.relatedTableKey] &&
            !!saved[this.relatedTableKey][this.relatedFormKey]
        ),
        map((saved) => saved[this.relatedTableKey][this.relatedFormKey])
      ),
      this.loadEditSubscribers(),
      this.store.pipe(
        select(getUserProfile),
        filter((data) => !!data)
      ),
    ]).subscribe((data) => {
      if(this.isActionOpened) return;
      this.savedFields = JSON.parse(JSON.stringify(data[0]));
      this.applicationTableAllFields = <Array<FormDataField>>data[1];

      this.resolveApplicationTableFieldsForAddMode();

      this.prepareFormFieldMeta();
      this.reloadableSubscribers.add(
      this.store.pipe(select(getSVGData)).subscribe((data: any) => {
        if (data && data.length) {
          data.forEach((iconData: any) => {
            if (!this.buttonIcons[iconData.icon]) {
              this.buttonIcons[iconData.icon.split('/').at(-1)] =
                iconData.iconValue
                  .replace(/width="[^"]*"/, `width="${'35px'}"`)
                  .replace(/height="[^"]*"/, `height="${'30px'}"`)
                  .replace(
                    /fill="[^"]*"/g,
                    `fill="${this.buttonIconNames[iconData.icon.split('/').at(-1)]
                      ? this.buttonIconNames[iconData.icon.split('/').at(-1)]
                      : '#fff'
                    }"`
                  );
            }
          });
        }
      }));
      if (
        Object.keys(this.buttonIconNames).length &&
        !Object.keys(this.buttonIcons).length
      ) {
        this.store.dispatch(
          new GetSVGData(
            Object.keys(this.buttonIconNames).map((icon: any) => {
              return this.getIconName(icon);
            })
          )
        );
      }
      this.isCustomBtnActive = this.savedFields.HasCustomButtons || false;
      this.isActionBtnActive =
        this.savedFields.HasCustomButtons ||
        this.savedFields.TabData.every((tab) => {
          return this.actionButtons.some(
            (btn) => tab[btn as keyof TabData] === true
          );
        });
      this.userRole = data[2]?.Role || '';
      this.currentUserEmail = data[2]?.Email || '';
      if(!this.isFormSubmittedOnce && !this.isFormInitialized) {
        this.initForm();
        this.listenForDependentField();
        this.isFormInitialized = true;
      }
      if (this.isUpdate) {
        const fields = <Array<FormDataField>>data[1];
        this.applicationTableAllFields = fields;
        if (!this.isColumnDropdownValueUpdated)
          this.fetchRelatedColumnDropdownValues();
        if (!this.isValueAdded) {
          this.ngZone.runOutsideAngular(async () => {
            await this.patchFormValues(fields);
            if (this.preserveFormOnEmbeddedTableSave) {
              this.isValueAdded = true;
            }
            // After patching values, apply rules if needed
            this.ngZone.run(() => {
              const shouldApplyRules = !this.isApplyRuleCalled || this.shouldReapplyRulesAfterSave;
              if (this.formRules?.length && this.savedFields?.TabData?.length && shouldApplyRules) {
                this.isApplyRuleCalled = true;
                this.shouldReapplyRulesAfterSave = false; // Reset flag after applying
                this.applyValueChanges();
              }
            });
          });
        }

        if (
          this.relationTabs?.length &&
          this.reportInForms?.length &&
          this.reportDetails?.DetailsRelation?.length
        ) {
          this.relationTabs = this.relationTabs.filter((tab: any) => {
            const reportKey = this.reportDetails.DetailsRelation.find(
              (relation: any) => relation.TableKey === tab.TableKey
            )?.ReportKey;
            if (reportKey && this.reportInForms.includes(reportKey)) {
              return false;
            }
            return true;
          });
          this.getReportsForForm();
        }
      }
      else if (this.isInModal && !!this.relatedParentValue && !!this.referenceFieldKey) {
        this.savedFields.TabData.forEach((tab: TabData) => {
          tab.Columns.forEach((col: Column) => {
            if (col.IsRelation && col.FieldKey === this.referenceFieldKey) {
              if (!col.DropdownValues?.some((item: any) => item['Value'] === this.relatedParentValue)) {
                this.action.dispatch(
                  OpTypes.LOAD,
                  new GetRelatedData(
                    this.isInModal ? this.relatedTableKey : this.route.getTableKey(),
                    col.FieldKey,
                    col?.DropdownLabelKey ? col.DropdownLabelKey : '',
                    false,
                    '',
                    false,
                    0,
                    20,
                    false,
                    Number(this.relatedParentValue ?? "0"),
                    '',
                    this.getRestrictChoices(col)
                  ),
                  getFormOperations,
                  this.defaultExtra
                ).then((data) => {
                  var dropdown = data?.payload?.find((item: any) => item.Value === this.relatedParentValue);
                  if (!!dropdown) {
                    this.columnDataList[col.FieldKey] = [{ label:dropdown.Name,value:dropdown.Value}];
                    this.fieldIdToGroup(col.FieldKey)?.controls?.RelatedFieldValue?.setValue(dropdown.Name);
                  }
                });
              }
            }
          });
        });
      }
      // Rules are now applied after patchFormValues completes (see above in isUpdate block)
      // For non-update cases, apply rules here
      if (!this.isUpdate && this.formRules && this.formRules.length && this.savedFields?.TabData?.length) {
        this.isApplyRuleCalled = true;
        this.applyValueChanges();
      }
      this.setTabHeaderWidth();
    }));

    // Subscribe Form Rules
    this.reloadableSubscribers.add(
    this.store
      .pipe(
        select(getformRules),
        filter(
          (saved) =>
            !!saved[this.relatedTableKey] &&
            !!saved[this.relatedTableKey][this.relatedFormKey]
        ),
        map((saved) => saved[this.relatedTableKey][this.relatedFormKey])
      )
      .subscribe(async (data: any) => {
        if (data) this.formRules = data;
        if (!this.isApplyRuleCalled && this.savedFields.TabData.length && this.formRules.length) {
          this.applyValueChanges();
        }
      }));

    //Subscribe Report details
    this.reloadableSubscribers.add(
    this.store
      .pipe(
        select(getReportDetails),
        filter(
          (details) =>
            !!details[
            this.isInModal ? this.relatedTableKey : this.route.getTableKey()
            ] &&
            !!details[
            this.isInModal ? this.relatedTableKey : this.route.getTableKey()
            ][this.isInModal ? this.embeddedReportKey : this.reportId] &&
            !!details[
            this.isInModal ? this.relatedTableKey : this.route.getTableKey()
            ][this.isInModal ? this.embeddedReportKey : this.reportId][
            this.isInModal ? this.recordId : this.id
            ]
        ),
        map(
          (details) =>
            details[
            this.isInModal ? this.relatedTableKey : this.route.getTableKey()
            ][this.isInModal ? this.embeddedReportKey : this.reportId][
            this.isInModal ? this.recordId : this.id
            ]
        )
      )
      .subscribe(async (details: any) => {
        details = JSON.parse(JSON.stringify(details));
        const formResponse = await this.getFormId(
            this.route?.getTableKey(),
            this.route?.paramMap?.reportId
          );
        if(formResponse) {
          details.FormKey = formResponse?.Key;
        }
        this.reportDetails = details;
        this.getReportsForForm();
        this.initialLoad = !this.relationTabs?.length;
        this.relationTabs = details.DetailsRelation.map(
          (detail: any, index: any) => {
          let ShowRelatedRecords:boolean = true;
          if (!detail.EmbeddedSetting?.AllowMatchRecords) {
            ShowRelatedRecords = true;
          } else if (this.initialLoad) {
            ShowRelatedRecords = true;
          } else {
            ShowRelatedRecords = !this.isMatchRelatedRecordAllowed(detail.ReportKey);
          }
          return {
            TableKey: detail.TableKey,
            TableName: (detail?.EmbeddedSetting?.AllowDisplayName && detail?.EmbeddedSetting?.DisplayName) ? detail?.EmbeddedSetting?.DisplayName : detail.TableName,
            Index: index,
            OriginalTableName: detail.TableName,
            ShowRelatedRecords: ShowRelatedRecords
          };
        }
      );
        if (
          this.relationTabs?.length &&
          this.reportInForms?.length &&
          this.reportDetails?.DetailsRelation?.length
        ) {
          this.relationTabs = this.relationTabs.filter((tab: any) => {
            const reportKey = this.reportDetails.DetailsRelation.find(
              (relation: any) => relation.TableKey === tab.TableKey
            )?.ReportKey;
            if (reportKey && this.reportInForms.includes(reportKey)) {
              return false;
            }
            return true;
          });
        }
        this.setTabValues();
      }));
  };

  prepareFormFieldMeta() {
    if (!this.isFormSubmittedOnce) {
      const userEmail = this.authService.userProfile.Email;
      const relatedNamesCache: Record<string, string> = {};
      const fieldValueMap = new Map(Array.isArray(this.applicationTableAllFields) ? this.applicationTableAllFields.map(f => [f.Key, f.Value]) : []);

      //  Process both TabData & HeaderFields in a single unified pass
      const allColumns = [
        ...this.savedFields.TabData.reduce((acc: Column[], tab) => {
          acc.push(...tab.Columns);
          return acc;
        }, []),
        ...this.savedFields.HeaderFields,
      ];

      for (const column of allColumns) {
        const { DbFieldType, DropdownValues, FieldKey, Key, FormStyleOption, FormFieldSetting } = column;

        //  1. USER Field Options
        if (DbFieldType === 'USER' && DropdownValues?.length) {
          const arr = [
            { value: userEmail, label: 'Current User' },
            ...DropdownValues
              .filter((ddv:any) => ddv.Value && ddv.Value !== userEmail)
              .map((ddv:any) => ({ value: ddv.Value, label: ddv.Name })),
          ];
          this.userFieldOptions.push({ FieldKey, DropdownValues: arr });
        }

        //  2. ENUM / ENUM2 Field filtering
        if ((DbFieldType === 'ENUM' || DbFieldType === 'ENUM2') && DropdownValues?.length) {
          const fieldValue = fieldValueMap.get(FieldKey);
          column.DropdownValues = DropdownValues.filter((option:any) => {
            if (option.IsActive) return true;
            if (!this.isUpdate) return false;
            if (!fieldValue) return false;

            return DbFieldType === 'ENUM'
              ? fieldValue === option.Value
              : fieldValue.split(';').includes(option.Value);
          });
        }

        //  3. Relation Field Options
        if (column.IsRelation && DropdownValues?.length) {
          const relatedName =
            column.RelatedTableSingularName ||
            relatedNamesCache[Key] ||
            (() => {
              const table = this.tableKeyOptions.find((t:any) => t.Key === column.RelatedTableKey);
              if (table) relatedNamesCache[Key] = table.SingularReference;
              return relatedNamesCache[Key] || column.Name.replace('Related ', '');
            })();

          const arr = DropdownValues.map((ddv:any) => ({
            value: ddv.Value,
            label: ddv.Name,
          }));

          if (this.isFormActionAllowed(column) && !this.isInModal) {
            const addNewLabel = `Add New ${relatedName}`;
            if (arr[0]?.label !== DROPDOWN_VALUE_PLACEHOLDER) {
              arr.unshift({ value: '', label: DROPDOWN_VALUE_PLACEHOLDER });
            }
            arr.unshift({ value: 'clickRelated', label: addNewLabel });
          }

          this.relatedOptions[FieldKey] = arr;
        }

        //  4. Report Field Defaults
        if (DbFieldType === 'report') {
          this.reportInForms.push(FormFieldSetting?.DefaultValue);
        }

        //  5. Default File Fields
        if (DbFieldType === 'FILE' && FormFieldSetting?.HasDefaultValue) {
          this.defaultFileFields.push(column);
        }

        //  6. Button Icon Mapping
        if (
          DbFieldType === 'BUTTON' &&
          FormStyleOption?.Icon &&
          !/(fluent-|material-icons-|fl-)/.test(FormStyleOption.Icon)
        ) {
          this.buttonIconNames[FormStyleOption.Icon] = FormStyleOption.TextColor;
        }
      }
    }
  }

  patchFormValues(fields: any) {
    return new Promise<void>((resolve) => {
      // Cache FormArray and create lookup map
      const fieldsList = this.form?.controls?.FieldsList as UntypedFormArray;
      const fieldIndexMap = new Map<string, number>();
      fieldsList?.controls?.forEach((group, index) => {
        if(fieldIndexMap.has(group.value.Key)) return;
        fieldIndexMap.set(group.value.Key, index);
      });

      // Cache relatedOptions lookups to avoid repeated .find()
      const relatedOptionsCache = new Map<string, string>();
      Object.keys(this.relatedOptions).forEach((key) => {
        const formGroup = fieldsList.controls.find((group) => group.value.Key === key) as UntypedFormGroup;
        if (formGroup?.controls?.FieldName?.value?.includes('related_')) {
          const option = this.relatedOptions[key]?.find(
            (opt: any) => opt.value === formGroup.controls.Value.value
          );
          relatedOptionsCache.set(key, option?.label || '');
        }
      });

      // Process updates in batches asynchronously
      const batchSize = 20; // Adjust based on testing
      const fieldEntries = Object.values(fields);
      let index = 0;

      const processBatch = () => {
        const end = Math.min(index + batchSize, fieldEntries.length);

        for (; index < end; index++) {
          const field:any = fieldEntries[index];
          const formIndex = fieldIndexMap.get(field.Key);
          if (formIndex === undefined) continue;

          const formGroup = fieldsList.at(formIndex) as UntypedFormGroup;
          formGroup.patchValue({
            FileUrl: field.FileUrl,
            IsSent: field.IsSent,
            IsFileMissing: field.IsFileMissing ?? false,
            DecryptedValue: field?.DecryptedValue,
            Value: this.getValue(field, formGroup.controls.Type.value),
            ...(relatedOptionsCache.has(field.Key) && {
              RelatedFieldValue: relatedOptionsCache.get(field.Key)
            })
          });
        }

        // Schedule next batch
        if (index < fieldEntries.length) {
          requestAnimationFrame(processBatch);
        } else {
          resolve();
        }
      };

      // Start processing
      requestAnimationFrame(processBatch);
    });
  }

  getFormId = (tableId: any, reportId: any) =>
    this.store
      .pipe(
        select(getFormIDs),
        filter((formId) => !!formId[tableId] && !!formId[tableId][reportId]),
        map((formId) => formId[tableId][reportId]),
        take(1)
      )
      .toPromise();


  getValue = (field: FormDataField, DbFieldType: string) => {
    if(
      (field.Name === 'datemodified' ||
      field.Name === 'datecreated' ||
      field.Name === 'createdby' ||
      field.Name === 'modifiedby') &&
      (this.isCopyRecord && !this.isRecordSaved)
    ){
      return '';
    }
    if (
      field.Name === 'datemodified' ||
      field.Name === 'datecreated' ||
      datecreatedRegex.test(field.Name) ||
      modifiedbyRegex.test(field.Name)
    ){
      return field.Value;
    }
    if (DbFieldType === 'DATE') {
      if (new RegExp(DATE_PATTERN_MM_DD_YYYY).test(field.Value)){
        return field.Value;
      }
      if (new RegExp(DATE_PATTERN_YYYY_MM_DD).test(field.Value)){
        return field.Value;
      }
    }
    if (DbFieldType === 'DATETIME') {
      if (new RegExp(DATE_PATTERN_MM_DD_YYYY_TIME).test(field.Value)){
        return moment(field.Value, 'MM-DD-YYYY hh:mm:ss A')
          .format('YYYY-MM-DD HH:mm');
      }
      if (new RegExp(DATE_PATTERN_MM_DD_YYYY_TIME_HOUR).test(field.Value)){
        return moment(field.Value, 'MM-DD-YYYY hh:mm:ss A')
          .format('YYYY-MM-DD HH:mm');
      }
      if (new RegExp(DATE_PATTERN_YYYY_MM_DD_TIME).test(field.Value)){
        return moment(field.Value, 'YYYY-MM-DD hh:mm:ss A')
          .format('YYYY-MM-DD HH:mm');
      }
    }
    if (DbFieldType === 'TINYINT(1)')
      return field.Value === 'True' ? true : field.Value === '1' ? true : false;
    if (field.Name == 'id' && (!this.isCopyRecord || this.isRecordSaved)) return this.recordId;
    if (DbFieldType === 'ENUM2') return field.Value ? field.Value.split(';') : [];
    return field.Value;
  };

  loadEditSubscribers = () =>
    this.isUpdate
      ? this.store.pipe(
        select(getFormData),
        filter(
          (data) =>
            !!data[this.relatedTableKey] &&
            !!data[this.relatedTableKey][this.relatedFormKey] &&
            !!data[this.relatedTableKey][this.relatedFormKey][this.recordId]
        ),
        map(
          (data) =>
            data[this.relatedTableKey][this.relatedFormKey][this.recordId]
        )
      )
      : of(true);

  /**
   * On Submit
   */
  onSubmit = async (): Promise<boolean> => {
    if ((this.isUpdate && !this.isCopyRecord) || (this.isCopyRecord && this.isRecordSaved)) {
      return await this.onEditSubmit();
    } else if (this.isCopyRecord) {
      return await this.onRecordSave(true);
    } else {
      return await this.onRecordSave();
    }
  };

  onRecordSave = async (isCopyRecord: boolean = false): Promise<boolean> => {
    try {
      if (!this.isFormValid()) {
        this.resetSubmittingToken++;
        return false;
      }

      this.saveDisabled = true;
      this.cdr.detectChanges();

      // Prepare payload
      const payload = isCopyRecord
        ? new CopyData(this.relatedTableKey, this.id, this.payload)
        : new PostData(this.relatedTableKey, this.payload);

      // CREATE or COPY record
      const createResponse: any = await this.action.dispatch(
        OpTypes.CREATE,
        payload,
        getFormOperations
      );

      this.isFormSubmittedOnce = true;
      this.recordId = createResponse?.payload?.recordId;
      this.isRecordSaved = true;

      // Sync child table pending rows before navigating away.
      // Do NOT call detectChanges first -- it would trigger ngOnChanges -> resyncPendingRows
      // which starts an async sync that gets aborted by navigation. Instead, let
      // syncPendingAndWait handle everything synchronously (it checks syncInFlight as a fallback).
      if (this.recordId && this.childTableComponents?.length > 0) {
        const syncPromises = this.childTableComponents.map(ct =>
          ct.syncPendingAndWait(String(this.recordId))
        );
        await Promise.all(syncPromises);
      }

      if (!this.isButtonClicked && this.allowClose) {
        this.closeActionScreen();
        return false;
      }

      // Save files/templates if present
      if (this.fileFields.length) {
        this.saveFiles(this.recordId);
      }

      if (this.templateFiles.length) {
        this.saveTemplates();
      }

      // LOAD the record
      // Set flag to trigger rules re-evaluation with fresh data after save
      this.shouldReapplyRulesAfterSave = true;

      await this.action.dispatch(
        OpTypes.LOAD,
        new LoadFormData(this.relatedTableKey, this.relatedFormKey, this.recordId),
        getFormOperations
      );

      // Post-load actions
      this.refreshReportDetails(true, true);
      this.isValueAdded = false;
      this.loadSubscribers();

      this.saveDisabled = false;
      this.resetSubmittingToken++;
      this.cdr.detectChanges();

      return true;

    } catch (err) {
      this.saveDisabled = false;
      this.resetSubmittingToken++;
      this.cdr.detectChanges();
      return false;
    }
  };

  onEditSubmit = async (): Promise<boolean> => {
    try {
      if (this.isFormValid()) {
        this.saveDisabled = true;
        this.cdr.detectChanges();
        let result = await this.action.dispatch(
          OpTypes.UPDATE,
          new PutData(this.recordId, this.relatedTableKey, {
            ...(<any>this.payload),
            Where: {
              Rid: this.recordId,
            },
          }),
          getFormOperations
        )
          .then(async (value: any) => {
            if (!this.isButtonClicked && this.allowClose) return false;
            this.isFormSubmittedOnce = true;
            // Set flag to trigger rules re-evaluation with fresh data after save
            this.shouldReapplyRulesAfterSave = true;

            await this.action.dispatch(
              OpTypes.LOAD,
              new LoadFormData(
                this.relatedTableKey,
                this.relatedFormKey,
                this.recordId
              ),
              getFormOperations
            ).then(async () => {
              if (this.isInModal) return;
              this.isValueAdded = false;
            })
            this.saveDisabled = false;
            this.resetSubmittingToken++;
            this.cdr.detectChanges();
            return true;
          })
          .catch(() => {
            this.saveDisabled = false;
            this.resetSubmittingToken++;
            this.cdr.detectChanges();
            throw new Error('Save failed');
          });
        this.closeActionScreen();
        return result;
      }
      this.resetSubmittingToken++;
      return false;
    } catch (err) {
      this.saveDisabled = false;
      this.resetSubmittingToken++;
      this.cdr.detectChanges();
      return false;
    }
  };

  closeActionScreen() {
    if (!this.isButtonClicked && this.allowClose) this.goBack(true);
    this.isButtonClicked = false;
  }

  messages: any = [];
  openMessageDialog() {
    if (Object.keys(this.displayMessages).length) {
      this.messages = [];
      Object.values(this.displayMessages).forEach(value => {
        this.messages.push(value);
      })
      if(Object.keys(this.modalRefs).length){
        this.modalRefs['MessageBox'].close();
        delete this.modalRefs['MessageBox'];
      }
      this.recordCommonTemplates.messages = this.messages;
      const modalRef = this.modal.open(this.recordCommonTemplates.displayMessageDialog, {
        windowClass: this.isInModal ? 'modal-custom modalField-custom modal-padding':'modal-custom modal-padding',
        centered: true,
        size: 'md',
        backdrop: 'static',
        animation: true,
        keyboard: false,
      });
      this.recordCommonTemplates.messageDialogClosed.subscribe((data) => {
        this.closeMessageModal(data);
      });
      this.modalRefs['MessageBox'] = modalRef;
    }
  }
  openTabSpecificModal() {
    if (this.tabSpecificMessages[this.currentTabIndex]?.length) {
      if(Object.keys(this.modalRefs).length && Object.keys(this.modalRefs)?.includes(this.tabIndex+'MessageBox')){
        this.modalRefs[this.tabIndex+'MessageBox'].close();
        delete this.modalRefs[this.tabIndex+'MessageBox'];
      }
      this.recordCommonTemplates.tabSpecificMessages = this.tabSpecificMessages;
      this.recordCommonTemplates.currentTabIndex = this.currentTabIndex;
      const modalRef = this.modal.open(this.recordCommonTemplates.tabDisplayMssageDialog, {
        windowClass: this.isInModal ? 'modal-custom modalField-custom modal-padding':'modal-custom modal-padding',
        centered: true,
        size: 'md',
        backdrop: 'static',
        animation: true,
        keyboard: false,
      });
      this.recordCommonTemplates.messageDialogClosed.subscribe((data) => {
        this.closeMessageModal(data);
      });
      this.modalRefs[this.tabIndex+'MessageBox'] = modalRef;
    }
  }

  get payload() {
    let val = JSON.parse(JSON.stringify(this.form.getRawValue()));
    for (let field in val.FieldsList) {
      let currentFieldDeleted = false;
      if (
        this.excludeFields.indexOf(val.FieldsList[field].Name) > -1 ||
        this.fieldsToBeAdded.includes(val.FieldsList[field].Key) ||
        this.buttonReferencedFieldsAdded.includes(val.FieldsList[field].Key) ||
        val.FieldsList[field]?.Type === 'HTML'  // Exclude all HTML display fields
      ) {
        delete val.FieldsList[field];
        currentFieldDeleted = true;
      } else {
        val.FieldsList[field].Name =
          val.FieldsList[field].DBName || val.FieldsList[field].Name;
        delete val.FieldsList[field].DBName;
        val.FieldsList[field].DropdownValues = [];
        if (val.FieldsList[field].Value == undefined) {
          if (
            this.readonlyFieldsValue[val.FieldsList[field].Key] != undefined
          ) {
            val.FieldsList[field].Value =
              this.readonlyFieldsValue[val.FieldsList[field].Key];
          }
        }
      }

      if (
        !currentFieldDeleted &&
        this.referenceFieldKey &&
        val.FieldsList[field].Key === this.referenceFieldKey
      ) {
        val.FieldsList[field].Value = this.relatedParentValue;
      }

      if (
        val.FieldsList[field]?.Type === 'FILE' &&
        val.FieldsList[field]?.FileUrl?.includes('/apps')
      )
        val.FieldsList[field].FileUrl = null;

      if (
        val.FieldsList[field]?.Type === 'FILE' &&
        this.defaultFileFields.some((col: Column) => col.FieldKey === val.FieldsList[field]?.Key) &&
        ((!this.isUpdate && val.FieldsList[field].Base64EncodedFile === '') ||
        (this.isUpdate && (val.FieldsList[field]?.Value === '' || val.FieldsList[field]?.Value === null)))
      ) {
        var column = this.defaultFileFields.find((col: Column) => col.FieldKey === val.FieldsList[field]?.Key)
        val.FieldsList[field].Base64EncodedFile = column?.FormFieldSetting?.DefaultFileData;
        val.FieldsList[field].Value = column?.FormFieldSetting.DefaultFileName;
      }

      if (
        val.FieldsList[field]?.Type === 'ENUM2' &&
        Array.isArray(val.FieldsList[field].Value)
      ) {
        val.FieldsList[field].Value = val.FieldsList[field]?.Value?.join(';');
      }
    }
    val.FieldsList = val.FieldsList.filter((e: any) =>
      !!e && (!e.IsHeader || this.valueChangedFields.includes(e.Key))
    );
    return val;
  }

  /**
   * Select input type on the basis of field type in database
   */
  inputTypeSelector = (field: Column) => {
    if (field.IsRelation && field.DropdownValues) {
      return this.selectSearchScroll;
    }
    if(field.IsFormulaField && field.IsUrlField && field.FormFieldSetting.RenderAsButton){
      return this.button;
    }
    if (field.IsUrlField && this.isFieldReadonly(field)) {
      return this.urlReadonly;
    }
    if (
      field.DropdownValues &&
      field.DropdownValues.length > 0 &&
      field.DbFieldType != 'USER' &&
      field.DbFieldType != 'ENUM2'
    )
      return this.select;
    let type = field.DbFieldType;
    if (
      field.FieldName === 'createdby' ||
      field.FieldName === 'modifiedby' ||
      createdbyRegex.test(field.FieldName) ||
      modifiedbyRegex.test(field.FieldName)
    )
      type = 'VARCHAR(255)';

    switch (type) {
      case 'FILE':
        return this.file;
      case 'TEXT':
        return this.textarea;
      case 'TINYINT(1)':
        return this.checkbox;
      case 'ENUM':
        return this.select;
      case 'ENUM2':
        return this.select2;
      case 'HTML':
        return this.html;
      case 'USER':
        return this.selectSearchScroll;
      case 'BUTTON':
        return this.button;
      case 'HEADER':
        return this.header;
      case 'DIVIDER':
        return this.divider;
      case 'COLLAPSIBLE':
        return this.collapse;
      case 'report':
        return this.report;
      case 'CHILD_TABLE':
        return this.childTableEnabled ? this.childTable : this.report;
      case 'INT':
      case 'VARCHAR(255)':
      case 'VARCHAR':
      default:
        return this.input;
    }
  };

  inputFieldAutocomplete = (field: Column): string => {
    switch (field.DbFieldType) {
      case 'EMAIL':
        return 'email';
      case 'VARCHAR(15)':
        return 'tel';
      default:
        return '';
    }
  };

  /**
   * Input field type (number, text etc)
   * @param field
   */
  inputFieldType = (field: Column) => {
    switch (field.DbFieldType) {
      case 'DATETIME':
        return 'datetime-local';
      case 'DATE':
        return 'date';
      case 'EMAIL':
        return 'email';
      case 'INT':
        if (
          field.FieldName === 'datemodified' ||
          field.FieldName === 'datecreated' ||
          datecreatedRegex.test(field.FieldName) ||
          datemodifiedRegex.test(field.FieldName)
        )
          return 'text';
        return 'number';
      case 'FILE':
        return 'file';
      case 'VARCHAR(255)':
      case 'VARCHAR':
      default:
        if (field.FieldType === 'number') return 'number';
        if (field.GeneralType === 'number') return 'number';
        return 'text';
    }
  };

  /**
   * Input field placeholder
   * @param field
   */
  inputFieldPlaceholder = (field: Column) => {
    switch (field.DbFieldType) {
      case 'PII':
      case 'PII2':
        if (field.IsNullable)
          return 'Enter here';
        return this.isUpdate ? 'Value can be only replaced!' : 'Enter here';
      case 'VARCHAR(15)':
        return '(000) 000-0000';
      case 'HTML':
        return field?.FormFieldSetting?.DefaultValue ?? '';
      default:
        return 'Enter here';
    }
  };

  getPIIField = (field: Column) => {
    return field.DbFieldType === 'PII' || field.DbFieldType === 'PII2'
      ? field
      : null;
  };

  isUserField = (field: Column) => {
    return field.DbFieldType == 'USER' || (field.IsRelation ? true : false);
  };

  isMultiSelectField = (field: Column) => {
    return field.DbFieldType == 'ENUM2';
  };

  isFormActionAllowed = (field: Column) => {
    if(field.IsFlyAdditionAllowed && (this.reportRecordService.isAdminOrSuperAdmin() || (field.IsRelation && this.reportRecordService.isAuthorizedParticipant('addRecord', field.RelatedTableKey || '')))){
      return true;
    }
    return false;
  };
  /**
   * Select options
   */
  selectOptions = (field: Column) => {
    if (field.DbFieldType == 'USER') {
      let index = -1;
      this.form.get('FieldsList')?.value.forEach((fg: any, ind: any) => {
        if (fg.Key == field.FieldKey) {
          index = ind;
        }
      });
      return ((this.form.get('FieldsList') as UntypedFormArray).at(index) as UntypedFormGroup)
        .value.DropdownValues;
    } else {
      return (field.DropdownValues as Array<any>)?.map((o) => ({
        value: o.Value,
        label: o.Name,
      }));
    }
  };

  setSelectedValue = (event: any, fg: UntypedFormGroup) => {
    if (event.value === 'clickRelated') {
      fg.patchValue({ Value: '' });
    } else {
      fg.patchValue({ Value: event.value,RelatedFieldValue: event.label  });
    }
  };

  relatedSelected = (event: any, col:any) => {
    this.formGroupAt(col)?.controls.Value.setValue(event);
    this.formGroupAt(col)?.controls.Value.updateValueAndValidity();
  };

  setMultiSelectedValue = (event: any, fg: UntypedFormGroup) => {
    if (event != null && event.length > 0) {
      event.forEach((e: any) => {
        if (e.value === 'click!') {
          let index = event.findIndex((f: any) => f.value === e.value);
          event.splice(index, 1);
        }
      });
    }
  };

  /**
   * On file select
   * @param event
   * @param field
   * @returns
   */
  fileSelect = async (event: any, field: Column, formGroup: UntypedFormGroup) => {
    if (field.DbFieldType !== 'FILE') return;
    let tempFile = event.target.files[0];
    let sizeLimit = 100;
    let sizeInMb = tempFile.size / 1024 / 1024;
    if (field.FormFieldSetting?.FileSize) {
      let fileSizeInMB = Number(field.FormFieldSetting.FileSize) / 1024;
      if (sizeInMb > fileSizeInMB) {
        this.alert.toast(
          ToastTypes.ERROR,
          'Error',
          `Size limit for import is ${field.FormFieldSetting?.FileSize}KB.`
        );
        return;
      }
    }
    if (sizeInMb > sizeLimit) {
      this.alert.toast(
        ToastTypes.ERROR,
        'Error',
        'Size limit for import is 100MB.'
      );
      return;
    }
    if (event.target.files.length && field?.FormFieldSetting?.FileExtension) {
      const fileType = '.' + event.target.files[0].type.split('/')[1];
      if (field.FormFieldSetting.FileExtension?.split(';').includes(fileType)) {
        const file = (await fileToBase64(event.target.files[0])) as any;
        formGroup.controls.Base64EncodedFile.setValue(file.value);
        formGroup.controls.Value.setValue(file.name);
      }
    } else {
      const file = (await fileToBase64(event.target.files[0])) as any;
      formGroup.controls.Base64EncodedFile.setValue(file.value);
      formGroup.controls.Value.setValue(file.name);
    }
  };

  /**
   * Get mask to set on input field
   * @param col
   */
  inputFieldMask = (col: Column) => {
    if (col.DbFieldType === 'VARCHAR(15)') return '(000) 000-0000';
    return '';
  };


  /**
   * @returns value to display in button or header
   */
  getFieldValue(col:Column){
    const value = this.fieldIdToControl(col.FormStyleOption?.ValueOfFieldKey || '')?.value;
    const formControlGroup = this.fieldIdToGroup(col.FormStyleOption?.ValueOfFieldKey || '') as UntypedFormGroup;
    const type = formControlGroup?.controls?.Type?.value;
    if (formControlGroup?.controls?.DBName?.value?.startsWith('related')){
      const relatedFieldType = formControlGroup?.controls?.DropdownLabelType?.value;
      return this.reportRecordService.getFormattedValue(relatedFieldType,formControlGroup?.controls?.RelatedFieldValue?.value, true, true);
    } else {
      return this.reportRecordService.getFormattedValue(type,value, true);
    }
  }

  /**
   * Get field value for condition checking, with fallback to applicationTableAllFields
   */
  private getFieldValueForCondition(fieldKey: string): any {
    const controlValue = this.controlMap.get(fieldKey)?.value;

    // Use control value if it's not empty/null/undefined
    if (controlValue !== '' && controlValue != null) {
      return controlValue;
    }

    if (Array.isArray(this.applicationTableAllFields)) {
      const field = this.applicationTableAllFields.find(f => f.Key === fieldKey || f.FieldName === fieldKey);
      if (field?.Value != null && field.Value !== '') {
        return field.Value;
      }
    }

    return controlValue ?? '';
  }

  /**
   * Gets the database field name for a given field key by checking multiple sources
   */
  private getDbFieldName(fieldKey: string): string {
    // Try savedFields TabData first
    let fieldName = this.getFieldName(fieldKey);
    if (fieldName) return fieldName;

    // Check HeaderFields
    fieldName = this.savedFields?.HeaderFields?.find((c: any) => c.FieldKey === fieldKey)?.FieldName ?? '';
    if (fieldName) return fieldName;

    // Check application table fields (for fields not on the form)
    const tableFields = this.tableKeyOptions?.find((t: any) => t.Key === this.relatedTableKey)?.Fields;
    return tableFields?.find((f: any) => f.Key === fieldKey)?.DbName ?? '';
  }

  /**
   * Checks if a field is a system date field (datecreated/datemodified)
   */
  private isSystemDateField(fieldName: string): boolean {
    return fieldName === 'datecreated' || fieldName === 'datemodified' ||
           datecreatedRegex.test(fieldName) || datemodifiedRegex.test(fieldName);
  }

  /**
   * Checks conditions by iterating
   * @returns true if condition staisfy
   */
  conditionsCheck = (
    ConditionType: 'all' | 'any' | '',
    Conditions: Array<any>
  ) => {
    const conditions = [];
    if (!ConditionType) return false;
    if (ConditionType && !Conditions.length) return false;

    const dateOperators = ['before_date', 'after_date', 'on_or_before_date', 'on_or_after_date', 'between_date', 'not_between_date', 'days_before_today'];

    for (let condition of Conditions) {
      let fieldValue = this.getFieldValueForCondition(condition.FieldKey);

      // For new records with empty datecreated/datemodified, use current datetime for date comparisons
      const isEmptyValue = fieldValue === '' || fieldValue == null;
      const isDateOperator = dateOperators.includes(condition.QueryCondition);
      if (!this.isUpdate && isEmptyValue && isDateOperator && this.isSystemDateField(this.getDbFieldName(condition.FieldKey))) {
        fieldValue = moment().format('YYYY-MM-DD HH:mm:ss');
      }

      conditions.push(this.compareValues(fieldValue, condition.QueryCondition, condition.Value));
    }
    return ConditionType === 'all'
      ? conditions.every((e) => e)
      : conditions.some((e) => e);
  };

  compareValues = (
    inputValue: string | number | boolean,
    operator: string,
    conditionValue: string | number | boolean
  ) => {
    let date1, date2;
    switch (operator) {
      case 'empty':
        return inputValue === '' || inputValue === null || inputValue === undefined || (Array.isArray(inputValue) && !inputValue.length);
      case 'has value':
        if(Array.isArray(inputValue)) return inputValue.length ? true: false;
        return inputValue || (inputValue !== '' && inputValue !== null && inputValue !== undefined) || (Array.isArray(inputValue) && inputValue.length);
      case 'true or false':
        inputValue = inputValue ? inputValue : false;
        return (
          inputValue ==
          (conditionValue === '1' || conditionValue === '0'
            ? conditionValue === '1'
              ? typeof inputValue === 'boolean'
                ? true
                : inputValue === '1' || inputValue === '0'
                  ? conditionValue
                  : 'True'
              : typeof inputValue === 'boolean'
                ? false
                : inputValue === '1' || inputValue === '0'
                  ? conditionValue
                  : 'False'
            : conditionValue)
        );
      case 'is equal to role':
      case 'is equal to user':
      case 'is equal':
        if(Array.isArray(inputValue)){
          return JSON.stringify(inputValue.sort()) === JSON.stringify((conditionValue as string).split(';')?.sort());
        }
        return (
          inputValue === conditionValue
        );
      case 'is not equal':
        if(Array.isArray(inputValue)){
          return JSON.stringify(inputValue.sort()) !== JSON.stringify((conditionValue as string).split(';')?.sort());
        }
        return inputValue != conditionValue;
      case 'contain':
        return inputValue?.toString()?.includes(conditionValue.toString());
      case 'not contain':
        return !inputValue?.toString()?.includes(conditionValue.toString());
      case 'start with':
        return inputValue?.toString()?.startsWith(conditionValue.toString());
      case 'end with':
        return inputValue?.toString()?.endsWith(conditionValue.toString());
      case 'greater than or equal to':
        return Number(inputValue) >= Number(conditionValue);
      case 'less than or equal to':
        return Number(inputValue) <= Number(conditionValue);
      case 'greater than':
        return Number(inputValue) > Number(conditionValue);
      case 'less than':
        return Number(inputValue) < Number(conditionValue);
      case 'between_date':
        date1 = (conditionValue as string).split(',')[0];
        date2 = (conditionValue as string).split(',')[1];
        return moment(inputValue as string).isBetween(
          moment(date1),
          moment(date2)
        );
      case 'not_between_date':
        date1 = (conditionValue as string).split(',')[0];
        date2 = (conditionValue as string).split(',')[1];
        return !moment(inputValue as string).isBetween(
          moment(date1),
          moment(date2)
        );
      case 'days_before_today':
        return (
          moment().diff(moment(inputValue as string), 'days') == conditionValue
        );
      case 'before_date':
        return (
          moment(inputValue as string).diff(
            moment(conditionValue as string),
            'days'
          ) < 0
        );
      case 'on_or_before_date':
        return (
          moment(inputValue as string).diff(
            moment(conditionValue as string),
            'days'
          ) <= 0
        );
      case 'after_date':
        return (
          moment(inputValue as string).diff(
            moment(conditionValue as string),
            'days'
          ) > 0
        );
      case 'on_or_after_date':
        return (
          moment(inputValue as string).diff(
            moment(conditionValue as string),
            'days'
          ) >= 0
        );
      case 'currentuser':
        return (
          this.currentUserEmail == inputValue ||
          this.currentUserEmail == conditionValue
        );
      case 'equal to value in field':
        return (
          this.fieldIdToControl(conditionValue as string)?.value == inputValue
        );
      case 'not equal to value in field':
        return (
          this.fieldIdToControl(conditionValue as string)?.value != inputValue
        );
      case 'greater than value in field':
        return (
          Number(this.fieldIdToControl(conditionValue as string)?.value) < Number(inputValue)
        );
      case 'less than value in field':
        return (
          Number(this.fieldIdToControl(conditionValue as string)?.value) > Number(inputValue)
        );
      case 'greater than or equal to value in field':
        return (
          Number(this.fieldIdToControl(conditionValue as string)?.value) <= Number(inputValue)
        );
      case 'less than or equal to value in field':
        return (
          Number(this.fieldIdToControl(conditionValue as string)?.value) >= Number(inputValue)
        );
      case 'is_in_the_role':
        return this.authService.userProfile.ApplicationRoles.some(
          (role: any) => role.Key === conditionValue
        );
      case 'is_not_in_the_role':
        return !this.authService.userProfile.ApplicationRoles.some(
          (role: any) => role.Key === conditionValue
        );
      default:
        return false;
    }
  };

  /**
   * @returns true if field is readonly
   */
  isFieldReadonly = (field: Column) => {
    if (
      field.FormFieldSetting.Readonly === 1 ||
      this.isColReadOnly(field.FieldKey) ||
      (this.referenceFieldKey != '' &&
        field.FieldKey === this.referenceFieldKey)
    ) {
      if (this.readonlyFieldsValue[field.FieldKey] == undefined)
        this.readonlyFieldsValue[field.FieldKey] =
          this.formGroupAt(field)?.controls?.Value?.value;
      return true;
    }

    if (field.IsHeader) {
      return true;
    }

    if (field.IsRelation && field.DependentFieldKey) {
      return !this.fieldIdToControl(field.DependentFieldKey)?.value;
    }
    if (field?.FormFieldSetting?.ConditionGroup?.[2]) {
      const { Conditions, ConditionType } =
        field?.FormFieldSetting?.ConditionGroup?.[2];
      var isReadonly =
        this.conditionsCheck(ConditionType, Conditions) ||
        field.IsSummaryField ||
        field.IsLookupField ||
        field.IsFormulaField ||
        field.FieldName === 'id' ||
        field.FieldName === 'createdby' ||
        field.FieldName === 'modifiedby' ||
        field.FieldName === 'datecreated' ||
        field.FieldName === 'datemodified';
      if (this.readonlyFieldsValue[field.FieldKey] == undefined && isReadonly) {
        this.readonlyFieldsValue[field.FieldKey] =
          this.formGroupAt(field)?.controls?.Value?.value;
      }
      return isReadonly;
    }
    return false;
  };

  /**
   * @returns true if field is hidden
   */
  isFieldHidden = (field: Column) => {
    if(!this.isUpdate) {
      if (
        field.FieldName == 'datemodified' ||
        field.FieldName == 'datecreated' ||
        field.FieldName == 'createdby' ||
        field.FieldName == 'modifiedby' ||
        field.IsFormulaField ||
        field.IsLookupField ||
        field.IsSummaryField
      ) {
        return true;
      }
    }
    if (
      field.FormFieldSetting.Hidden === 1 ||
      this.isColHidden(field.FieldKey) ||
      this.isStyleOptionHidden(field.FieldName)
    )
      return true;
    if (field?.FormFieldSetting?.ConditionGroup?.[1]) {
      const { Conditions, ConditionType } =
        field?.FormFieldSetting?.ConditionGroup?.[1];
      return this.conditionsCheck(ConditionType, Conditions);
    }
    return false;
  };

  /**
   * Set required fields on the basis of conditions applied
   */
  setRequiredFields = () => {
    const requiredFields = this.savedFields.TabData.map((e,index) =>
      e.Columns.map((e: any) => ({
        fieldId: e.FieldKey,
        dbType: e.DbFieldType,
        conditionGroup: e?.FormFieldSetting?.ConditionGroup?.[0],
        isNullable: e.IsNullable,
        required:
          this.isTabHidden(index) && !this.isFieldReadonly(e) && !this.isFieldHidden(e)
            ? e.FormFieldSetting.Required || this.isColRequired(e.FieldKey)
            : false,
      }))
    )
      .reduce((p, n) => p.concat(n), [])
      .map((f) => ({
        fieldId: f.fieldId,
        dbType: f.dbType,
        isNullable: f.isNullable,
        isRequired:
          f.required ||
          this.conditionsCheck(
            f.conditionGroup?.ConditionType,
            f.conditionGroup?.Conditions
          ),
      }));
    requiredFields.forEach((field) => {
      const control = this.fieldIdToControl(field.fieldId);
      if (field.isRequired) {
        this.addValidators(control, 'required', 255);
      } else {
        control?.clearValidators();
      }

      if (field.dbType === 'TINYINT(1)' && field.isRequired) {
        this.addValidators(control, 'requiredTrue', '');
      }
      if(field.dbType === 'PII2' && !field.isNullable){
        this.addValidators(control, 'required', 255);
        this.addValidators(control, 'noSpaceValidator', '');
      }
      control?.updateValueAndValidity({ emitEvent: false });
    });
  };

  /**
   * Set field maxlength based on Dbfieldtype
   */
  setFieldsMaxLength = () => {
    const requiredFields = this.savedFields.TabData
      .map((tab) =>
        tab.Columns.map((col) => ({
          fieldId: col.FieldKey,
          dbtype: col.DbFieldType,
          min: col.FormFieldSetting.Minimum,
          max: col.FormFieldSetting.Maximum,
          charCount: col.FormFieldSetting.CharacterCount,
          regex: col.FormFieldSetting.Regex,
          maxLength: col.FieldSize,
          isNullable: col.IsNullable,
        }))
      ).reduce((p, n) => p.concat(n), []);

    requiredFields.forEach((field) => {
      this.setUpValidatorsOnControls(field);
    });
  };

  addValidators(control: any, validationToBeAdded: string, extraParam?: any) {
    if (!control) return;

    const existing = control.validator ? [control.validator] : [];
    const newValidators: any[] = [...existing];

    const validatorMap: Record<string, () => any> = {
      maxLength: () => extraParam ? Validators.maxLength(extraParam) : null,
      required: () => Validators.required,
      min: () => extraParam ? Validators.min(extraParam) : null,
      max: () => extraParam ? Validators.max(extraParam) : null,
      regex: () => (control: AbstractControl) => this.validateRegexWithEncryptedValue(control, extraParam),
      email: () => [Validators.email, Validators.pattern(EMAIL_PATTERN)],
      requiredTrue: () => Validators.requiredTrue,
      noSpaceValidator: () => noOnlySpacesValidator(),
      uuid: () => this.uuidValidator,
    };

    const val = validatorMap[validationToBeAdded]?.();
    if (val) {
      if (Array.isArray(val)) {
        val.forEach((v) => {
          if (!newValidators.includes(v)) newValidators.push(v);
        });
      } else if (!newValidators.includes(val)) {
        newValidators.push(val);
      }
    }

    const uniqueValidators = Array.from(new Set(newValidators));

    control.setValidators(Validators.compose(uniqueValidators));
  }

  validateRegexWithEncryptedValue(control: AbstractControl, pattern: string) {
    if (!pattern) return null;

    const validatePattern = Validators.pattern(pattern);
    const error = validatePattern(control);
    if (!error || !control.value) return null;

    // If there's an error, check if the field is encrypted (masked). Ex. '***123456'
    const fieldKey = control.parent?.get('Key')?.value;
    // originalField is the initial state from the server
    const originalField = this.applicationTableAllFields?.find((f: any) => f.Key === fieldKey);
    // If the originalField was encrypted and the current value is the same as that encrypted/masked value
    if (originalField?.IsEncrypted && control.value === originalField.Value) {
      // Simply return valid, we'll trust the server state
      return null;
    }
    return error;
  }

  setUpValidatorsOnControls(field: any) {
    const control: any = this.fieldIdToControl(field.fieldId);

    // Numeric validations
    if (
      ['INT', 'TINYINT(1)', 'DOUBLE', 'DECIMAL(20,2)'].includes(field.dbtype) &&
      (field.min || field.max)
    ) {
      this.addValidators(control, 'min', field.min);
      this.addValidators(control, 'max', field.max);
    }

    // String validations
    if (field.dbtype === 'VARCHAR') {
        const lengthCandidates = [field.maxLength, field.charCount, 255].filter(
      (val) => typeof val === 'number' && val > 0
    );
    const effectiveLength = Math.min(...lengthCandidates);
    this.addValidators(control, 'maxLength', effectiveLength);
    }

    if (['VARCHAR(255)', 'PII', 'PII2'].includes(field.dbtype)) {
      this.addValidators(control, 'maxLength', field.charCount || 255);
    }

    if (field.dbtype === 'TEXT') {
      this.addValidators(control, 'maxLength', field.charCount || 65535);
    }

    // Regex handling for all applicable fields
    if (
      ['VARCHAR', 'VARCHAR(255)', 'PII', 'PII2', 'TEXT'].includes(field.dbtype) &&
      field.regex
    ) {
      this.addValidators(control, 'regex', field.regex);
    }

    // Email validation
    if (field.dbtype === 'EMAIL') {
      this.addValidators(control, 'email', '');
    }

    // Special case for PII2
    if (field.dbtype === 'PII2' && !field.isNullable) {
      this.addValidators(control, 'required', 255);
      this.addValidators(control, 'noSpaceValidator', '');
    }

    if (['CHAR(36)', 'UUID'].includes(field.dbtype)) {
      this.addValidators(control, 'uuid', '');
    }

    control?.updateValueAndValidity({ emitEvent: false });
  }

  goBack = (isSubmit:boolean = false) => {
    if (this.modalLayer !== 0) {
      this.modal.dismissAll((isSubmit || (this.isInModal && this.isSaveContinueClicked)) ? (this.isRelatedOptionAdding ? `Submit_${this.recordId}`:'Submit') : 'Cancel');
    } else {
      this.route.back();
    }
  };

  isHtmlAllowed = (col: any) => {
    return col?.IsFormulaField && col?.IsHtmlAllowed;
  };

  async tabClick(event: any) {
    if (event.target?.id == 'prev' && this.tabIndex > 0) {
      this.tabIndex -= 1;
      if (!this.isTabHidden(this.tabIndex)) {
        this.tabIndex -= 1;
      }
      this.addFormValidators();
      this.commonService.scrollToTop();
    } else if (event.target?.id == 'saveExit') {
      this.allowClose = true;
      await this.onSubmit(); // No tabIndex change for saveExit
    } else if (event.target?.id == 'next') {
      this.tabIndex += 1;
      this.addFormValidators();
      if (!this.isTabHidden(this.tabIndex)) {
        this.tabIndex += 1;
      }
      this.commonService.scrollToTop();
    } else if (event.target?.id == 'saveNext') {
      if (this.isFormValid()) {
        this.allowClose = false;
        const submitSuccess = await this.onSubmit();
        if (submitSuccess) {
          this.tabIndex += 1;
          this.isSaveContinueClicked = true;
          if (!this.isTabHidden(this.tabIndex)) {
            this.tabIndex += 1;
          }
          this.addFormValidators();
        }
      }
      this.commonService.scrollToTop();
    } else if (event.target?.id == 'cancel') {
      this.goBack();
    }
  }

  getDocRouteLink = (col: Column, type: string) => {
    if (type === 'new') {
      if(this.recordId){
        var new_window = window.open(
          `/apps/${this.route.getApplicationKey()}/tables/${col.ApplicationTableKey
          }/doc-new/${col.FieldKey}/${this.recordId}`,
          '_blank',
          'directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,width=1800,height=800,left=0,top=0'
        );
      } else {
        var new_window = window.open(
          `/apps/${this.route.getApplicationKey()}/tables/${col.ApplicationTableKey
          }/doc-new/${col.FieldKey}`,
          '_blank',
          'directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,width=1800,height=800,left=0,top=0'
        );
      }
      new_window!.addEventListener('beforeunload', () => {
        this.isValueAdded = false;
        if(this.recordId){
          this.refreshReportDetails();
        } else {
          this.fileFields.push(col.FieldKey);
          this.fieldIdToControl(col.FieldKey)?.setValue(localStorage.getItem(`${this.relatedTableKey}_${col.FieldKey}_name`));
          this.templateFiles = this.templateFiles.filter((field:any)=> field !== col.FieldKey)
        }
        new_window!.removeEventListener('beforeunload', () => {});
      });
    } else if (type === 'edit') {
      var new_window = window.open(
        `/apps/${this.route.getApplicationKey()}/tables/${col.ApplicationTableKey
        }/doc-edit/${col.FieldKey}/${this.recordId}`,
        '_blank',
        'directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,width=1800,height=800,left=0,top=0'
      );
      new_window!.addEventListener('beforeunload', () => {
        this.isValueAdded = false;
        this.refreshReportDetails();
        new_window!.removeEventListener('beforeunload', () => {});
      });
    }
    return;
  };

  isDoc = (col: Column) => {
    const val = this.formGroupAt(col)?.controls?.Value?.value;
    if (val?.toLowerCase()?.includes('.doc')) return true;
    return false;
  };

  isSpreadsheet = (col: Column) => {
    const val = this.formGroupAt(col)?.controls?.Value?.value;
    if (
      val?.toLowerCase()?.includes('.csv') ||
      val?.toLowerCase()?.includes('.xls')
    )
      return true;
    return false;
  };

  isDocEnabled = (col: Column) => {
    if (col.EnableDoc) return true;
    return false;
  };

  isDocumentSent = (col: Column) => {
    const isSent = this.formGroupAt(col)?.value?.IsSent;
    if (col.FormFieldSetting?.ESignEnabled && isSent) return true;
    return false;
  };

  ngOnDestroy() {
    this.subscribers.unsubscribe();
    this.reloadableSubscribers.unsubscribe();
    this.store.dispatch(new ResetFormRule());
    this.fileFields.forEach((field:any)=> {
      localStorage.removeItem(`${this.relatedTableKey}_${field}_name`)
      localStorage.removeItem(`${this.relatedTableKey}_${field}_file`)
    });
    this.templateFiles.forEach((field:any)=> {
      localStorage.removeItem(`${this.relatedTableKey}_${field}_name`)
      localStorage.removeItem(`${this.relatedTableKey}_${field}_file`)
    });
    this.fileMissingTooltip.clearTimers();
  }

  refreshReportDetails = (isRecordAdding: boolean = false,onRecordAdd:boolean = false) => {
    // GABSW-2137: Conditionally skip LoadFormData dispatch based on feature flag
    const shouldSkipDispatch = this.preserveFormOnEmbeddedTableSave && onRecordAdd;

    if (!shouldSkipDispatch) {
      this.store.dispatch(
        new LoadFormData(
          this.route.getTableKey(),
          this.route.paramMap.formId,
          this.id
        )
      );
      this.isValueAdded = false
    }
    if (isRecordAdding && !this.isInModal) {
      this.loadDetailRelations();
    }
  };

  onRecordDelete(event: any) {
    if (event) {
      this.refreshReportDetails(true, true);
    }
  }

  reports: any = {};
  reportInForms: any = [];

  getReportsForForm() {
    this.reportInForms.forEach((report: any) => {
      this.getReportDatas(report);
    });
  }

  getReportDatas(column: any) {
    const data = this.reportDetails?.DetailsRelation?.filter((relation: any) => relation.ReportKey === column);
    const reportIndex = this.reportDetails?.DetailsRelation?.findIndex((relation: any) => relation.ReportKey === column);
    if (data?.length) {
      this.reports = {
        ...this.reports,
        [column]: {
          ...data[0],
          ReferenceFieldKey:
            data[0]?.ChildData?.ReferenceFieldKey || data[0]?.ReferenceFieldKey,
          LookupFieldValue: data[0].ChildData.LookupFieldValue,
          ApplicationKey: this.route.getApplicationKey(),
          ShowRelatedRecords: !data[0].EmbeddedSetting?.AllowMatchRecords ? true : !this.reports[column]
                ? true
                : (this.isMatchRelatedRecordAllowed(data[0].ReportKey)
                  ? false
                  : true),
          OriginalTableName: data[0].TableName,
          TableName: (data[0].EmbeddedSetting?.AllowDisplayName && data[0].EmbeddedSetting?.DisplayName) ? data[0].EmbeddedSetting?.DisplayName : data[0].TableName
        }
      };
      this.reportDetails!.DetailsRelation[reportIndex].isReportInForm = true;
    }
  }

  showCol(col: any) {
    return (
      Object.keys(this.reports).length &&
      Object.keys(this.reports[col.FormFieldSetting.DefaultValue]).length
    );
  }

  isTabHidden(index: any) {
    return (
      (this.userRole === 'admin' &&
        !this.savedFields.TabData[index].HideForAdmin) ||
      (this.userRole === 'participant' &&
        !this.savedFields.TabData[index].HideForParticipants) ||
      this.userRole === 'super_admin'
    );
  }

  setTabValues() {
    for (let tab in this.savedFields.TabData) {
      if (this.isTabHidden(tab)) {
        break;
      } else if (!this.isTabHidden(tab)) {
        this.tabIndex += 1;
      }
    }
  }

  deleteDocument() {
    const valueCtrl = this.formGroupAt(this.columnToDelete)?.controls?.['Value'];
    valueCtrl?.reset();
    if (this.isA11yFileInputEnabled) {
      valueCtrl?.markAsDirty();
      valueCtrl?.markAsTouched();
    }
    this.formGroupAt(this.columnToDelete)?.controls?.['Base64EncodedFile']?.reset();
    this.deleteModalRef?.close();
  }

  confirmDeleteDocument() {
    const col = this.columnToDelete;
    this.deleteDocument();
    if (this.isA11yFileInputEnabled) {
      // Return focus to the parent file input label after confirm
      setTimeout(() => {
        const container = this.el.nativeElement.querySelector(
          `[data-file-field="${col?.FieldKey}"]`
        );
        const fileLabel = container?.querySelector('#customFileInputLabel') as HTMLElement;
        fileLabel?.focus();
      });
    }
  }

  cancelDeleteDocument() {
    const col = this.columnToDelete;
    this.deleteModalRef?.close();
    if (this.isA11yFileInputEnabled) {
      // Return focus to the delete button after cancel
      setTimeout(() => {
        const deleteBtn = this.el.nativeElement.querySelector(
          `#delete-doc-btn-${col?.FieldKey}-${col?.IsHeader}`
        );
        deleteBtn?.focus();
      });
    }
  }

  deleteModalRef!:NgbModalRef;

  openDeleteModal(deleteModal: any, col: any) {
    this.columnToDelete = col;
    this.deleteModalRef = this.modal.open(deleteModal, {
      windowClass: `${this.isInModal ? 'modalField-custom':'modal-custom'} modal-padding`,
      centered: true,
      size: 'md',
      backdrop: 'static',
      animation: true,
      keyboard: false,
      ...(this.isA11yFileInputEnabled ? {
        ariaLabelledBy: 'delete-doc-modal-title',
        ariaDescribedBy: 'delete-doc-modal-desc',
      } : {}),
    });
    if (this.isA11yFileInputEnabled) {
      // Focus the confirm button after the modal opens
      this.deleteModalRef.shown.subscribe(() => {
        // Briefly focus the modal title so VoiceOver announces the dialog context,
        // then move focus to the confirm button
        const title = document.getElementById('delete-doc-modal-title') as HTMLElement;
        if (title) {
          title.setAttribute('tabindex', '-1');
          title.focus();
          setTimeout(() => {
            const confirmBtn = document.querySelector('.delete-modal-confirm-btn') as HTMLElement;
            confirmBtn?.focus();
          }, 100);
        } else {
          const confirmBtn = document.querySelector('.delete-modal-confirm-btn') as HTMLElement;
          confirmBtn?.focus();
        }
      });
    }
  }

  applyValueChanges() {
    this.ruleFields = [];
    const fieldConditions = [
      'equal to value in field',
      'not equal to value in field',
      'greater than value in field',
      'less than value in field',
      'greater than or equal to value in field',
      'less than or equal to value in field'
    ]
    this.formRules.forEach((formRule: any, index: any) => {
      if(formRule.IsFormRuleActive){
        const ruleField: any = {
          rule: index,
          rulesField: [],
          rulesUser: [],
        };
        formRule.FormConditionGroups.forEach((conditionGroup: any) => {
          conditionGroup.FormGroups.forEach((formGroup: any) => {
            formGroup.FormConditions.forEach((condition: any) => {
              if (
                condition.ConditionGroupType === 'field' &&
                !ruleField.rulesField.includes(condition.FieldKey) &&
                !this.isConditionFieldReadOnly(condition.FieldKey)
              ) {
                ruleField.rulesField.push(condition.FieldKey);
              } else if (condition.ConditionGroupType === 'user') {
                ruleField.rulesUser.push(true);
              }

              if(fieldConditions.includes(condition.QueryCondition) &&
                condition.ConditionGroupType === 'field' &&
                !ruleField.rulesField.includes(condition.Value) &&
                !this.isConditionFieldReadOnly(condition.Value)
              ) {
                ruleField.rulesField.push(condition.Value);
              }
            });
          });
        });
        this.ruleFields.push(ruleField);
      }
    });
    this.ruleFields.forEach((rules: any) => {
      if (rules.rulesField.length) {
        this.fieldValueChange = [];
        this.changeValuePerformed = [];
        this.initFormValueChange(this.formRules[rules.rule], rules.rule);
        rules.rulesField.forEach((fieldkey: any) => {
          this.reloadableSubscribers.add(
          this.fieldIdToControl(fieldkey)
            ?.valueChanges.pipe(debounceTime(300), distinctUntilChanged())
            .subscribe((data: any) => {
              this.fieldValueChange = [];
              this.changeValuePerformed = [];
              this.initFormValueChange(this.formRules[rules.rule], rules.rule);
            }));
        });
      } else if (rules.rulesUser.length) {
        this.fieldValueChange = [];
        this.changeValuePerformed = [];
        this.initFormValueChange(this.formRules[rules.rule], rules.rule);
      } else {
        this.fieldValueChange = [];
        this.changeValuePerformed = [];
        this.initFormValueChange(this.formRules[rules.rule], rules.rule);
      }
    });
  }

  initFormValueChange(rules: any, ruleIndex: any) {
    const conditionGroupCheck: any = [];
    rules.FormConditionGroups.forEach((conditionGroup: any) => {
      const formConditionCheck: any = {
        conditionType: conditionGroup.ConditionType,
        formConditions: [],
      };
      conditionGroup.FormGroups.forEach((ruleGroup: any) => {
        const isFormValid = this.conditionsCheck(
          ruleGroup.ConditionType,
          ruleGroup.FormConditions
        );
        formConditionCheck.formConditions.push(isFormValid);
      });
      conditionGroupCheck.push(formConditionCheck);
    });

    if (conditionGroupCheck.length) {
      this.resetHiddenArrys(ruleIndex);
      if (this.applyThenCondition(conditionGroupCheck)) {
        let showDisplaymessages = false;
        rules.FormRuleConditions.forEach((ruleCondition: any) => {
          switch (ruleCondition.Type) {
            case 'field':
              this.setRulesOnField(ruleCondition, ruleIndex);
              break;
            case 'styleoption':
              this.setRulesOnStyleOptions(
                ruleCondition,
                ruleCondition.Action,
                ruleIndex
              );
              break;
            case 'message':
              if(ruleCondition.DisplayMessage){
                if(ruleCondition.AllTabsSelected){
                  this.displayMessages[`rule${ruleIndex}`] = ruleCondition.Value;
                } else {
                  const tabs = ruleCondition.SelectedTabs?.split(';');
                  tabs?.forEach((tab:any) => {
                    if(this.tabSpecificMessages[tab] && !this.tabSpecificMessages[tab].find((message:any) => message === ruleCondition.Value)){
                      this.tabSpecificMessages[tab].push(ruleCondition.Value)
                    } else {
                      this.tabSpecificMessages[tab] = [ruleCondition.Value]
                    }
                  });
                }
                showDisplaymessages = true;
              }
              // Track rules with PreventSave enabled
              if (ruleCondition?.PreventSave) {
                this.preventSaveRules.add(ruleIndex);
              }
              // Update saveDisabled based on whether any rules have PreventSave active
              this.saveDisabled = this.preventSaveRules.size > 0;
              this.ruleIndexArr.push(ruleIndex);
              break;
            case 'change':
              this.fieldValueChange.push({
                FieldKey: ruleCondition.FieldKey,
                Value: ruleCondition.Value,
              });
              break;
          }
        });
        if (showDisplaymessages) {
          if(Object.keys(this.displayMessages).length){
            this.openMessageDialog();
          } else if(this.tabSpecificMessages?.[this.currentTabIndex]?.length){
            this.openTabSpecificModal();
          }
        }
        if (
          this.fieldValueChange.length &&
          !this.changeValuePerformed.includes('rule' + ruleIndex)
        ) {
          this.changeFieldValues(ruleIndex);
        }
      } else {
        rules.FormRuleConditions.forEach((ruleCondition: any) => {
          switch (ruleCondition.Type) {
            case 'field':
              this.removeRuleOnField(ruleCondition, ruleIndex);
              break;
            case 'styleoption':
              this.setRulesOnStyleOptions(ruleCondition, 'remove', ruleIndex);
              break;
            case 'message':
              if(ruleCondition.DisplayMessage){
                if(ruleCondition.AllTabsSelected){
                  delete this.displayMessages[`rule${ruleIndex}`];
                } else if(ruleCondition.SelectedTabs) {
                  const tabs = ruleCondition.SelectedTabs?.split(';');
                  tabs?.forEach((tab:any) => {
                    this.tabSpecificMessages[tab] = this.tabSpecificMessages[tab]?.filter(
                      (message: any) => message !== ruleCondition.Value
                    );
                  });
                }
              }
              // Remove this rule from PreventSave tracking when condition is false
              if (ruleCondition?.PreventSave) {
                this.preventSaveRules.delete(ruleIndex);
              }
              // Update saveDisabled based on whether any rules have PreventSave active
              this.saveDisabled = this.preventSaveRules.size > 0;
              break;
            case 'change':
              this.fieldValueChange = [];
              break;
          }
        });
      }
    }
  }

  resetHiddenArrys(index: any) {
    if (this.ruleIndexArr.includes(index)) {
      delete this.displayMessages[`rule${index}`];
      this.ruleIndexArr = [];
    }
  }

  setRulesOnField(condition: any, ruleIndex: any) {
    const fieldKey = condition.FieldKey || condition.Value;
    const control = this.fieldIdToControl(fieldKey);
    switch (condition.Action) {
      case 'hide':
        this.showHideField(fieldKey, true, ruleIndex);
        break;
      case 'read_only':
        this.makeFieldDisabled(fieldKey, true, ruleIndex);
        break;
      case 'require':
        this.makeFieldRequired(fieldKey, true, control, ruleIndex);
        break;
    }
  }

  removeRuleOnField(condition: any, ruleIndex: any) {
    const fieldKey = condition.FieldKey || condition.Value;
    const control = this.fieldIdToControl(fieldKey);
    switch (condition.Action) {
      case 'hide':
        this.showHideField(fieldKey, false, ruleIndex);
        break;
      case 'read_only':
        this.makeFieldDisabled(fieldKey, false, ruleIndex);
        break;
      case 'require':
        this.makeFieldRequired(fieldKey, false, control, ruleIndex);
        break;
    }
  }

  setRulesOnButton(condition: any) {
    const tabIndex = condition.Value.split('_')[0].at(-1);
    const buttonId = condition.Value.split('_')[1];
    if (condition.Action === 'show') {
      this.buttonShowArray.push({
        tabIndex: +tabIndex - 1,
        buttonId,
      });
    } else if (condition.Action === 'hide') {
      this.buttonHideArray.push({
        tabIndex: +tabIndex - 1,
        buttonId,
      });
    } else if (condition.Action === 'read_only') {
      this.buttonDisabled.push({
        tabIndex: +tabIndex - 1,
        buttonId,
      });
    }
  }

  setRulesOnStyleOptions(condition: any, action: any, ruleIndex: any) {
    if (action === 'remove') {
      const conditionValue = 'rule' + ruleIndex + '_' + condition.Value;
      this.styleOptionHideArray = this.styleOptionHideArray.filter(
        (option: any) => option !== conditionValue
      );
    } else if (action === 'hide') {
      this.styleOptionHideArray.push(
        'rule' + ruleIndex + '_' + condition.Value
      );
    }
  }

  applyThenCondition(rule: any) {
    if (rule.every((condition: any) => condition.conditionType === 'all')) {
      return rule.every((condition: any) =>
        condition.formConditions.every((e: boolean) => e)
      );
    } else {
      const isRuleValid: any = [];
      rule.forEach((condition: any) => {
        if (condition.conditionType === 'all') {
          isRuleValid.push(condition.formConditions.every((e: boolean) => e));
        } else {
          isRuleValid.push(condition.formConditions.some((e: boolean) => e));
        }
      });
      return isRuleValid.every((e: boolean) => e);
    }
  }

  getButtonStatus(tabIndex: any, id: any) {
    if (id == 'Previous') {
      return tabIndex != 0 && this.savedFields.TabData[tabIndex].Previous;
    } else if (id == 'Next') {
      return (
        tabIndex != this.rowColMap.length - 1 &&
        this.savedFields.TabData[tabIndex].Next
      );
    } else if (id == 'SaveAndContinue') {
      return this.savedFields.TabData[tabIndex].SaveAndContinue;
    } else if (id == 'SaveAndExit') {
      return this.savedFields.TabData[tabIndex].SaveAndExit;
    } else if (id == 'Cancel') {
      return this.savedFields.TabData[tabIndex].Cancel;
    }
    return;
  }

  makeFieldDisabled(fieldkey: any, disable: boolean, ruleIndex: any) {
    const field = 'rule' + ruleIndex + '_' + fieldkey;

    this.savedFields.TabData.forEach((tab: TabData) => {
      tab.Columns.forEach((col: Column) => {
        if (col.FieldKey === fieldkey) {
          if (disable) {
            this.colReadOnlyArr.push(field);
          } else {
            this.colReadOnlyArr = this.colReadOnlyArr.filter(
              (colField: any) => colField !== field
            );
          }
        }
      });
    });
  }

  makeFieldRequired(
    fieldkey: any,
    require: boolean,
    control: any,
    ruleIndex: any
  ) {
    const field = 'rule' + ruleIndex + '_' + fieldkey;
    this.savedFields.TabData.forEach((tab: TabData) => {
      tab.Columns.forEach((col: Column) => {
        if (col.FieldKey === fieldkey) {
          if (require) {
            this.colRequireArr.push(field);
          } else {
            this.colRequireArr = this.colRequireArr.filter(
              (colField: any) => colField !== field
            );
          }
        }
      });
    });
    if (this.savedFields.TabData.length > 1 && this.isActionBtnActive) {
      this.addFormValidators();
    } else if (
      this.savedFields.TabData.length == 1 ||
      !this.isActionBtnActive
    ) {
      this.setRequiredFields();
    }
  }

  showHideField(fieldkey: any, hidden: boolean, ruleIndex: any) {
    const field = 'rule' + ruleIndex + '_' + fieldkey;
    this.savedFields.TabData.forEach((tab: TabData) => {
      tab.Columns.forEach((col: Column) => {
        if (col.FieldKey === fieldkey) {
          if (hidden) {
            this.colHideArr.push(field);
          } else {
            this.colHideArr = this.colHideArr.filter(
              (colField: any) => colField !== field
            );
          }
        }
      });
    });
  }

  childTableValidationStates = new Map<string, boolean>();

  get hasChildTableErrors(): boolean {
    let hasErrors = false;
    this.childTableValidationStates.forEach((hasError) => {
      if (hasError) hasErrors = true;
    });
    return hasErrors;
  }

  onChildTableValidationStatusChange(fieldKey: string, hasErrors: boolean): void {
    this.childTableValidationStates.set(fieldKey, hasErrors);
    this.cdr.detectChanges();
  }

  shouldDisableCustomButton(col: Column): boolean {
    if (!this.enableCustomButtonDisabled) return false;

    if (col.IsFooter) {
      const fn = col.FormStyleOption?.ButtonClickFunction;
      if (fn === 'prev' || fn === 'next' || fn === 'cancel') {
        return false;
      }
    }

    return this.form.invalid || this.saveDisabled || this.hasChildTableErrors;
  }

  isFormValid() {
    if (this.form.invalid) {
      if (this.isA11yFileInputEnabled) {
        // Mark all invalid controls as dirty and touched so inline error messages appear
        for (let control of (this.form.controls.FieldsList as UntypedFormArray)
          .controls) {
          if (control.invalid) {
            const valueCtrl = control.get('Value');
            valueCtrl?.markAsDirty();
            valueCtrl?.markAsTouched();
            valueCtrl?.updateValueAndValidity({ emitEvent: false });
          }
        }
      }

      for (let control of (this.form.controls.FieldsList as UntypedFormArray)
        .controls) {
        if (control.invalid) {
          if (control.get('Value')?.hasError('pattern')) {
            const fieldType = control.get('Type')?.value;
            if (['CHAR(36)', 'UUID'].includes(fieldType)) {
              this.alert.toast(
                ToastTypes.ERROR,
                'Error',
                `${control.value.Name} is not a valid UUID format`
              );
              return false;
            }
          }
          this.alert.toast(
            ToastTypes.ERROR,
            `${control.value.Name} is required`,
            'Error'
          );
          return false;
        }
      }
    }
    if(!this.payload.FieldsList.length && this.isUpdate){
      this.alert.toast(
        ToastTypes.ERROR,
        'Update failed',
        'System fields cannot be modified. Please check your inputs'
      )
      return false;
    }
    if (this.childTableComponents?.length > 0) {
      for (const ct of this.childTableComponents) {
        if (ct.hasValidationErrors()) {
          this.alert.toast(
            ToastTypes.ERROR,
            'Error',
            'Please fill in all required fields in the child table before saving.'
          );
          return false;
        }
      }
    }
    return true;
  }

  isConditionFieldReadOnly(fieldKey: any): boolean {
    const fixedFields = ['id', 'createdby', 'modifiedby', 'datecreated', 'datemodified'];

    const column = this.tabDataFieldsMap[fieldKey];
    if (column) {
      if (
        column.IsSummaryField ||
        column.IsFormulaField ||
        column.IsLookupField ||
        fixedFields.includes(column.FieldName)
      ) {
        return true;
      }

      if (
        column.IsRelation && column.DependentFieldKey ||
        column.FieldKey === this.referenceFieldKey ||
        column.FormFieldSetting.Readonly
      ) {
        return false;
      }

      return this.isFieldReadonly(column);
    }

    return false;
  }

  addFormValidators() {
    this.savedFields.TabData.forEach((tab: TabData, index: number) => {
      // Only process visible tabs up to current index
      if (index <= this.tabIndex && this.isTabHidden(index)) {
        const requiredFields = tab.Columns.map((col: any) => ({
          fieldId: ['HTML', 'report'].includes(col.DbFieldType)
            ? col.FieldName
            : col.FieldKey,
          conditionGroup: col?.FormFieldSetting?.ConditionGroup?.[0],
          required:
            !this.isFieldReadonly(col) &&
            !this.isFieldHidden(col) &&
            (col.FormFieldSetting.Required ||
              this.isColRequired(col.FieldKey) ||
              this.conditionsCheck(
                col.FormFieldSetting?.ConditionGroup?.[0]?.ConditionType,
                col.FormFieldSetting?.ConditionGroup?.[0]?.Conditions
              )),
          dbtype: col.DbFieldType,
          min: col.FormFieldSetting.Minimum,
          max: col.FormFieldSetting.Maximum,
          charCount: col.FormFieldSetting.CharacterCount,
          regex: col.FormFieldSetting.Regex,
          maxLength: col.maxLength,
          isNullable: col.IsNullable,
        }));

        requiredFields.forEach((field) => {
          const control = this.fieldIdToControl(field.fieldId);

          // Required / optional handling
          if (field.required) {
            this.addValidators(control, 'required', 255);
          } else {
            control?.clearValidators();
          }

          // Special case: boolean checkbox (TINYINT)
          if (field.dbtype === 'TINYINT(1)' && field.required) {
            this.addValidators(control, 'requiredTrue', '');
          }

          this.setUpValidatorsOnControls(field);
        });
      } else {
        // Tab is hidden or not relevant: clear validators
        tab.Columns.forEach((col: Column) => {
          const control = this.fieldIdToControl(
            ['report', 'HTML'].includes(col.DbFieldType) ? col.FieldName : col.FieldKey
          );
          control?.clearValidators();
          control?.updateValueAndValidity({ emitEvent: false });
        });
      }
    });
  }

  closeMessageModal(isTabSpecific:boolean = false) {
    if(!isTabSpecific){
      this.displayMessages = {};
    }
    this.ruleIndexArr = [];
  }

  listenForDependentField() {
    this.savedFields.TabData.forEach((tab: TabData) => {
      tab.Columns.forEach((column: Column) => {
        if (column.IsRelation && column?.DependentFieldKey) {
          let dependentFieldName: any;
          this.savedFields.TabData.forEach((tab: TabData) => {
            tab.Columns.forEach((col: Column) => {
              if (col.FieldKey === column.DependentFieldKey) {
                dependentFieldName = col.FieldName;
              }
            })
          })
          if(this.isInModal && this.relatedParentValue && this.referenceFieldKey === column.DependentFieldKey){
            this.dispatchDependentValueFetch(this.relatedParentValue, column, dependentFieldName);
          }
          this.reloadableSubscribers.add(
          this.fieldIdToControl(column.DependentFieldKey)?.valueChanges?.pipe(distinctUntilChanged())?.subscribe((data: any) => {
            if(!data) return;
            this.dispatchDependentValueFetch(+data, column, dependentFieldName);
          }));
        }
      });
    });
  }

  dispatchDependentValueFetch(value:number,column:any, dependentFieldName: string){
    this.store.dispatch(new GetRelatedData(
      this.isInModal ? this.relatedTableKey : this.route.getTableKey(),
      column.FieldKey,
      column?.DropdownLabelKey ? column.DropdownLabelKey : '',
      false,
      '',
      false,
      0,
      20,
      false,
      value,
      dependentFieldName,
      this.getRestrictChoices(column)
    ));
  }

  isStyleOptionHidden(fieldName: any) {
    return this.styleOptionHideArray.some(
      (option: any) => option.split('_')[1] === fieldName
    );
  }
  isColHidden(fieldKey: any) {
    return this.colHideArr.some(
      (option: any) => option.split('_')[1] === fieldKey
    );
  }
  isColReadOnly(fieldKey: any) {
    return this.colReadOnlyArr.some(
      (option: any) => option.split('_')[1] === fieldKey
    );
  }
  isColRequired(fieldKey: any) {
    return this.colRequireArr.some(
      (option: any) => option.split('_')[1] === fieldKey
    );
  }

  /**
   * Converts button action field values to match backend expectations
   * @param fieldValue The value from FieldChangeValue
   * @param fieldGroup The form group for the field
   * @returns Object with converted value and updated type
   */
  private convertButtonFieldValue(fieldValue: any, fieldGroup: UntypedFormGroup | null): { value: any; type: string | null } {
    const fieldType = fieldGroup?.value?.Type;
    const currentValue = fieldGroup?.get('Value')?.value;

    // Detect checkbox fields by checking if current value is boolean-like (True/False)
    const isCheckboxField = (
      fieldType === 'TINYINT(1)' ||
      fieldType === 'TINYINT' ||
      currentValue === 'True' ||
      currentValue === 'False' ||
      currentValue === true ||
      currentValue === false
    );

    if (!isCheckboxField) {
      return { value: fieldValue.Value, type: null };
    }

    // Convert checkbox values to match details.component.ts format
    if (fieldValue.Value === 'true' || fieldValue.Value === 'True' || fieldValue.Value === true || fieldValue.Value === '1') {
      return { value: 'true', type: 'boolean' };
    } else if (fieldValue.Value === 'false' || fieldValue.Value === 'False' || fieldValue.Value === false || fieldValue.Value === '0') {
      return { value: 'false', type: 'boolean' };
    }

    return { value: fieldValue.Value, type: null };
  }

  applyButtonActions(column: Column) {
    if (column.IsFooter) {
      this.onFooterButtonClick(column);
    } else if(column.IsFormulaField && column.IsUrlField){
      if(column.FormFieldSetting.OpenInline){
        window.open(`${this.fieldIdToControl(column.FieldKey)?.value}`,'_self')
      } else{
        window.open(`${this.fieldIdToControl(column.FieldKey)?.value}`,'_blank')
      }
    } else {
      column.FormStyleOption?.FieldChangeValue?.forEach((fieldValue) => {
        const control = this.fieldIdToControl(fieldValue.FieldKey);
        const fieldGroup = this.fieldIdToGroup(fieldValue.FieldKey);

        if (control) {
          // Convert value using helper method
          const converted = this.convertButtonFieldValue(fieldValue, fieldGroup);

          // Update Type if it's a checkbox field
          if (converted.type && fieldGroup) {
            fieldGroup.patchValue({ Type: converted.type });
          }

          control.setValue(converted.value);

          if(fieldGroup?.value?.IsHeader){
            this.valueChangedFields.push(fieldValue.FieldKey);
          }

          // Remove from buttonReferencedFieldsAdded so it gets included in the payload
          const buttonRefIndex = this.buttonReferencedFieldsAdded.indexOf(fieldValue.FieldKey);
          if (buttonRefIndex > -1) {
            this.buttonReferencedFieldsAdded.splice(buttonRefIndex, 1);
          }

          if (this.isUpdate) {
            if (this.fieldsToBeAdded.includes(fieldValue.FieldKey)) {
              this.fieldsToBeAdded.splice(
                this.fieldsToBeAdded.findIndex(
                  (field: any) => field === fieldValue.FieldKey
                ),
                1
              );
            }
          }
        }
      });
      if (
        column.FormStyleOption?.FieldAddRecord &&
        column.FormStyleOption.FieldAddRecord.length
      ) {
        this.addRecords(column.FormStyleOption?.FieldAddRecord);
      }
      if (column.FormStyleOption?.IsSaveAndExit) {
        this.allowClose = true;
        this.isButtonClicked = false;
      } else {
        this.isButtonClicked = true;
      }
      if (this.saveDisabled) {
        return;
      }

      // Trigger change detection and allow setValue to propagate
      this.cdr.detectChanges();

      // Small delay to ensure form values are updated before submit
      setTimeout(() => {
        this.onSubmit();
      }, 50);
    }
  }

  /**
   * Display text for read-only URL / Formula URL fields (matches view page: LinkText or style name or URL value).
   */
  getReadonlyUrlDisplayText(col: Column): string {
    const val = this.fieldIdToControl(col.FieldKey)?.value;
    if (col.LinkText && val) return col.LinkText;
    if (col.FormFieldSetting?.FormFieldStyle?.Name) return col.FormFieldSetting.FormFieldStyle.Name;
    return val ?? '';
  }

  /**
   * Open URL when read-only URL or Formula URL link is clicked (same behavior as details view).
   */
  openReadonlyUrlLink(col: Column): void {
    const val = this.fieldIdToControl(col.FieldKey)?.value;
    if (!val) return;

    if (
      col.IsExternalUrl ||
      (typeof val === 'string' && (val.includes('http:') || val.includes('https:')))
    ) {
      if (col.FormFieldSetting?.OpenInline) {
        window.open(val, '_self');
      } else {
        window.open(val, '_blank');
      }
      return;
    }

    const parts = typeof val === 'string' ? val.split('/')?.slice(3) : [];
    const [appId, tableId, id, reportId] = parts;
    if (appId && tableId && id !== undefined && reportId !== undefined) {
      this.route.navigate([
        'apps',
        appId,
        'tables',
        tableId,
        'reports',
        this.isProcessReport(reportId) ? 'process' : 'details',
        'view',
        id,
        reportId,
      ]);
    }
  }

  private isProcessReport(reportKey: string): boolean {
    return !!this.reportDetails?.DetailsRelation?.find(
      (relation: any) => relation.ReportKey === reportKey
    )?.ProcedureKey;
  }

  getIconName(icon: string) {
    return 'assets/images/icons/default-app-icons-svg/' + icon;
  }

  changeFieldValues(index: any) {
    if (this.fieldValueChange.length) {
      this.fieldValueChange?.forEach((fieldValue: any) => {
        if (this.fieldIdToControl(fieldValue.FieldKey)) {
          this.changeValuePerformed.push('rule' + index);
          this.fieldIdToControl(fieldValue.FieldKey)?.setValue(fieldValue.Value);
          if(this.fieldIdToGroup(fieldValue.FieldKey)?.value?.IsHeader){
            this.valueChangedFields.push(fieldValue.FieldKey);
          }
          if (this.isUpdate) {
            if (this.fieldsToBeAdded.includes(fieldValue.FieldKey)) {
              this.fieldsToBeAdded.splice(
                this.fieldsToBeAdded.findIndex(
                  (field: any) => field === fieldValue.FieldKey
                ),
                1
              );
            }
          }
        }
      });
    }
  }

  addRecords(recordsToBeAdded: any) {
    const tablesWithField: any = {};
    recordsToBeAdded.forEach((record: any) => {
      if (Object.keys(tablesWithField).includes(record.TableKey)) {
        tablesWithField[record.TableKey].push({
          FieldKey: record.FieldKey,
          Value: record.Value,
        });
      } else {
        tablesWithField[record.TableKey] = [];
        tablesWithField[record.TableKey].push({
          FieldKey: record.FieldKey,
          Value: record.Value,
        });
      }
    });

    if (Object.keys(tablesWithField).length) {
      Object.keys(tablesWithField).forEach((tableId) => {
        const fieldList: any = [];
        tablesWithField[tableId].forEach((field: any) => {
          fieldList.push({
            Base64EncodedFile: '',
            DropdownValues: [],
            FieldName: '',
            Info: '',
            IsHeader: false,
            IsSent: false,
            Key: field.FieldKey,
            Name: '',
            Type: '',
            Value: field.Value,
          });
        });
        const payload = {
          ApplicationTableKey: tableId,
          FieldsList: fieldList,
        };
        this.submit(payload, tableId);
      });
    }
  }

  submit = async (payload: any, tableId: any) => {
    try {
      await this.action
        .dispatch(
          OpTypes.CREATE,
          new PostData(tableId, <any>payload),
          getFormOperations
        )
        .then(async (value: any) => { });
    } catch (err) { }
  };

  formTabChange(event: any) {
    this.currentTabIndex = event.index;
    this.openTabSpecificModal();
    if (this.enableAccessibleFormTabs) {
      this.focusActiveTab();
    }
  }

  /**
   * Handles keyboard navigation for tabs (left/right arrow keys only)
   * Only allows navigation to tabs that are clickable/enabled
   * @param event - The keyboard event
   */
  onTabKeyDown(event: KeyboardEvent) {
    if (!this.enableAccessibleFormTabs) return;

    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') {
      return;
    }

    const totalTabs = this.savedFields.TabData.length;
    let newIndex = this.currentTabIndex;
    const direction = event.key === 'ArrowLeft' ? -1 : 1;

    event.preventDefault();

    // Find the next available tab in the specified direction
    for (let i = 1; i <= totalTabs; i++) {
      newIndex = (this.currentTabIndex + (direction * i) + totalTabs) % totalTabs;

      // Check if this tab is available (not disabled and visible)
      if (this.isTabAccessible(newIndex)) {
        this.navigateToTab(newIndex);
        break;
      }
    }
  }

  /**
   * Checks if a tab is accessible for keyboard navigation
   * @param index - The tab index to check
   * @returns true if the tab is accessible
   */
  private isTabAccessible(index: number): boolean {
    // Tab must be visible (isTabHidden returns true for visible tabs)
    // and not disabled (isActionBtnActive controls the disabled state)
    return this.isTabHidden(index) && !this.isActionBtnActive;
  }

  /**
   * Navigates to a specific tab
   * @param index - The index of the tab to navigate to
   */
  private navigateToTab(index: number) {
    if (index !== this.currentTabIndex && this.isTabAccessible(index)) {
      this.currentTabIndex = index;
      this.tabIndex = index;
      this.openTabSpecificModal();
      this.cdr.detectChanges();
    }
  }

  private focusActiveTab() {
    setTimeout(() => {
      const activeTab = this.el.nativeElement.querySelector(
        '.record-action-mat-group .mdc-tab--active, .record-action-mat-group .mat-tab-label-active'
      );
      if (activeTab) {
        activeTab.focus();
      }
    });
  }

  openTemplateModal = async (col: Column) => {
    let modal = this.modal.open(AddTemplate, {
      windowClass: !this.isInModal ? 'modal-custom' : 'modalField-custom',
      centered: true,
      size: 'lg',
      backdrop: 'static',
      animation: true,
      keyboard: false,
    });
    modal.componentInstance.modalLayer = 0;
    modal.componentInstance.recordId = this.recordId;
    modal.componentInstance.tableId = col?.ApplicationTableKey;
    modal.componentInstance.appId = this.route.getApplicationKey();
    modal.componentInstance.fieldId = col?.FieldKey;
    modal.componentInstance.modalRef = modal;
    modal.result
      .then(() => {
        if(this.recordId){
          this.isValueAdded = false;
          this.refreshReportDetails();
        } else {
          this.templateFiles.push(col.FieldKey);
          this.fieldIdToControl(col.FieldKey)?.setValue(localStorage.getItem(`${this.relatedTableKey}_${col.FieldKey}_name`));
          this.fileFields = this.fileFields.filter((field:any)=> field !== col.FieldKey)
        }
      })
      .catch(() => {
        if(this.recordId){
          this.isValueAdded = false;
          this.refreshReportDetails();
        } else {
          this.templateFiles.push(col.FieldKey);
          this.fieldIdToControl(col.FieldKey)?.setValue(localStorage.getItem(`${this.relatedTableKey}_${col.FieldKey}_name`));
          this.fileFields = this.fileFields.filter((field:any)=> field !== col.FieldKey)
        }
      });
  };

  setTabHeaderWidth() {
    const tabHeader = this.el.nativeElement.querySelectorAll('.mat-tab-header');
    const sideNavBar = document.querySelector('.right-side-nav');
    if (sideNavBar) {
      tabHeader.forEach((header: any) => {
        if (sideNavBar.classList.contains('.collapse-menu')) {
          this.renderer.setStyle(header, 'max-width', '92vw');
        } else {
          this.renderer.setStyle(header, 'max-width', '83vw');
        }
      });
      this.reloadableSubscribers.add(
      this.commonService.toggleSideBar.subscribe((value: any) => {
        tabHeader.forEach((header: any) => {
          if (sideNavBar.classList.contains('collapse-menu')) {
            this.renderer.setStyle(header, 'max-width', '92vw');
          } else {
            this.renderer.setStyle(header, 'max-width', '83vw');
          }
        });
        this.cdr.detectChanges();
      }));
    }
  }

  isPdf = (col: Column) => {
    const val = this.formGroupAt(col)?.controls?.Value?.value;
    if (val?.toLowerCase()?.includes('.pdf')) return true;
    return false;
  };

  displayChatBot(event: any, col: any) {
    event.preventDefault();
    const chatbox: any = document.getElementById(
      `divContainer-${col.FieldKey}-${col.IsHeader}`
    );
    chatbox.style.display = chatbox?.style.display == 'none' ? 'block' : 'none';
  }

  isColumnWithDisplayOnScreen(col: Column) {
    if (!col.IsHeader) {
      return this.rowColMap?.[col.TabIndex]?.[col.DisplayRowIndex]?.some(
        (column) => column.FormFieldSetting?.DisplayType == 1
      );
    }
    return false;
  }

  openAddEditRelatedModal(
    detailRelation: any,
    id: any = '',
    tableId: any = '',
    reportId:any = ''
  ) {
    if (!detailRelation) return;
    let modal = this.modal.open(ActionsComponent, {
      windowClass: 'modal-custom modal-padding',
      centered: true,
      size: 'xl',
      backdrop: 'static',
      animation: true,
      keyboard: false,
    });
    modal.componentInstance.modalLayer = 1;

    this.isActionOpened = true;
    var lookupFieldValue = '';
    lookupFieldValue = detailRelation?.ChildData?.LookupFieldValue
      ? detailRelation.ChildData.LookupFieldValue
      : detailRelation?.LookupFieldValue;

    if(!(this.isMatchRecordAllowed(reportId) || this.isMatchRelatedRecordAllowed(reportId))) {
    modal.componentInstance.relatedParentValue = lookupFieldValue;
    }
    modal.componentInstance.referenceFieldKey = detailRelation?.ReferenceFieldKey
      ? detailRelation.ReferenceFieldKey
      : detailRelation?.ChildData?.ReferenceFieldKey;
    modal.componentInstance.relatedTableKey =
      tableId || detailRelation.TableKey
        ? detailRelation.TableKey
        : detailRelation.ApplicationTableKey;

    modal.componentInstance.relatedFormKey = !(this.isMatchRecordAllowed(reportId) || this.isMatchRelatedRecordAllowed(reportId)) ? detailRelation.FormKey : detailRelation.EmbeddedSetting?.MatchRecordsRelatedFormKey;

    modal.componentInstance.isInModal = true;
    modal.componentInstance.reportName =
      detailRelation?.TableSingularName || detailRelation.TableName;
    modal.componentInstance.recordId = null;
    modal.componentInstance.embeddedReportKey = detailRelation.ReportKey;
    if (id) {
      modal.componentInstance.modalRecordId = id;
    }
    this.preventFilter = true;
    this.subscribers.unsubscribe();
    if (modal && modal.result && typeof modal.result.then === 'function') {
      modal.result.then(
        (value:any) => {},
        (reason:any) => {
          if(reason === 'Submit'){
            this.store.dispatch(new LoadFormID(this.route.getTableKey(), this.route.paramMap.reportId));
            this.refreshReportDetails(true, true);
            this.preventFilter = false;
            this.isActionOpened = false;
          }
        }
      ).catch((err) => {
        this.isActionOpened = false;
      });
    }
  }

  openViewRelatedRecord(
    detailRelation: any,
    id: any = '',
    tableId: any = '',
    reportId:any = '',
    formId: any = '',
  ) {
    import('../details/details.component').then(({ DetailsComponent }) => {
      let modal = this.modal.open(DetailsComponent, {
        windowClass: 'modal-custom modal-padding',
        centered: true,
        size: 'xl',
        backdrop: 'static',
        animation: true,
        keyboard: false,
      });
      modal.componentInstance.modalLayer = 1;
      var lookupFieldValue = '';
      lookupFieldValue = detailRelation.ChildData.LookupFieldValue
        ? detailRelation.ChildData.LookupFieldValue
        : detailRelation?.LookupFieldValue;
      modal.componentInstance.relatedParentValue = lookupFieldValue;
      modal.componentInstance.relatedTableKey =
        tableId || detailRelation.TableKey
          ? detailRelation.TableKey
          : detailRelation.ApplicationTableKey;
      modal.componentInstance.relatedFormId = formId || !(this.isMatchRecordAllowed(reportId) || this.isMatchRelatedRecordAllowed(reportId)) ? detailRelation.FormKey : detailRelation.EmbeddedSetting?.MatchRecordsRelatedFormKey;
      modal.componentInstance.isInModal = true;
      modal.componentInstance.relatedReportName =
        detailRelation?.TableSingularName || detailRelation.TableName;
      modal.componentInstance.relatedReportId = reportId;
      if (id) {
        modal.componentInstance.modalRecordId = id;
      }
      this.preventFilter = true;
      modal.result
        .then(() => {
          this.preventFilter = false;
        })
        .catch(() => {
          this.preventFilter = false;
        });
    });

  }

  onFooterButtonClick(col: Column) {
    if (
      col.FormStyleOption?.ButtonClickFunction == 'prev' &&
      this.tabIndex > 0
    ) {
      if (this.savedFields.TabData.length === 1) return;
      this.tabIndex -= 1;
      if (!this.isTabHidden(this.tabIndex)) {
        this.tabIndex -= 1;
      }
      this.addFormValidators();
      this.commonService.scrollToTop();
    } else if (col.FormStyleOption?.ButtonClickFunction == 'saveExit') {
      if (col.FormStyleOption.EvaluateTab) {
        this.addFormValidators();
      } else {
        this.setRequiredFields();
      }
      this.allowClose = true;
      this.onSubmit();
    } else if (col.FormStyleOption?.ButtonClickFunction == 'next') {
      if (this.savedFields.TabData.length === 1) return;
      this.tabIndex += 1;
      this.addFormValidators();
      if (!this.isTabHidden(this.tabIndex)) {
        this.tabIndex += 1;
      }
      this.commonService.scrollToTop();
    } else if (col.FormStyleOption?.ButtonClickFunction == 'saveNext') {
      if (col.FormStyleOption.EvaluateTab) {
        this.addFormValidators();
      } else {
        this.setRequiredFields();
      }
      if (this.isFormValid()) {
        this.allowClose = false;
        this.isSaveContinueClicked = true;
        this.onSubmit();
        if (this.savedFields.TabData.length > 1) {
          this.tabIndex += 1;
          if (!this.isTabHidden(this.tabIndex)) {
            this.tabIndex += 1;
          }
          this.addFormValidators();
        }
      }
      this.commonService.scrollToTop();
    } else if (col.FormStyleOption?.ButtonClickFunction == 'cancel') {
      this.goBack();
    }
  }

  hideTabRows(col: Column) {
    const collapseName = `tab${col.TabIndex}_collapse${col.DisplayRowIndex}`;
    if (this.collapsedFieldArray.find((field: any) => field == collapseName)) {
      this.collapsedFieldArray = this.collapsedFieldArray.filter(
        (field: any) => field != collapseName
      );
      const firstname = collapseName.split('_')[0];
      const lastname = collapseName.split('_')[1];
      this.tabRowCollapsedArray = this.tabRowCollapsedArray.filter(
        (rowField: any) =>
          !(rowField.includes(firstname) && rowField.includes(lastname))
      );
    } else {
      this.collapsedFieldArray.push(collapseName);
      const tab = this.rowColMap[col.TabIndex];
      const rowIndex = col.DisplayRowIndex;
      for (let i = rowIndex + 1; i < tab.length; i++) {
        if (tab[i][0].DbFieldType !== 'COLLAPSIBLE') {
          this.tabRowCollapsedArray.push(
            `tab${col.TabIndex}_row${i}_collapse${rowIndex}`
          );
        } else {
          break;
        }
      }
    }
  }

  hideHeaderRows(col: Column) {
    const collapseName = `header_collapse${col.DisplayRowIndex}`;
    if (this.collapsedFieldArray.find((field: any) => field == collapseName)) {
      this.collapsedFieldArray = this.collapsedFieldArray.filter(
        (field: any) => field != collapseName
      );
      this.headerRowCollapsedArray = this.headerRowCollapsedArray.filter(
        (rowField: any) => !rowField.includes(collapseName.split('_')[1])
      );
    } else {
      this.collapsedFieldArray.push(collapseName);
      const header = this.headerRowMap;
      const rowIndex = col.DisplayRowIndex;
      for (let i = rowIndex + 1; i < header.length; i++) {
        if (header[i][0].DbFieldType !== 'COLLAPSIBLE') {
          this.headerRowCollapsedArray.push(
            `header_row${i}_collapse${rowIndex}`
          );
        } else {
          break;
        }
      }
    }
  }

  isRowCollapsed(col: Column) {
    const collapseName = `${col.IsHeader ? 'header' : 'tab' + col.TabIndex
      }_collapse${col.DisplayRowIndex}`;
    return this.collapsedFieldArray.find((field: any) => field == collapseName);
  }

  isTabRowCollapsed(row: any) {
    const rowName = `tab${row[0]?.TabIndex}_row${row[0]?.DisplayRowIndex}`;
    return this.tabRowCollapsedArray.find((rowField: any) =>
      rowField.includes(rowName)
    );
  }

  isHeaderRowCollapsed(row: any) {
    const rowName = `header_row${row[0]?.DisplayRowIndex}`;
    return this.headerRowCollapsedArray.find((rowField: any) =>
      rowField.includes(rowName)
    );
  }

  fetchRelatedColumnDropdownValues = async () => {
    if (Array.isArray(this.applicationTableAllFields) && !!this.savedFields) {
      var relatedRecordsFields = this.applicationTableAllFields?.filter(
        (record) => record.Name?.includes('related_')
      );
      const relatedRecordKeys = relatedRecordsFields.map(field => field.Key);
      const promises: Promise<any>[] = [];
      this.savedFields.TabData.forEach((tab: TabData) => {
        tab.Columns.forEach((col: Column) => {
          if (col.IsRelation && relatedRecordKeys?.includes(col.FieldKey)) {
            var relatedRecord = relatedRecordsFields.find((item) => item.Key == col.FieldKey);
            if (relatedRecord?.Value && !col.DropdownValues?.some((item: any) => item['Value'] === relatedRecord?.Value)) {
              const promise = this.action.dispatch(
                OpTypes.LOAD,
                new GetRelatedData(
                  this.isInModal ? this.relatedTableKey : this.route.getTableKey(),
                  col.FieldKey,
                  col?.DropdownLabelKey ? col.DropdownLabelKey : '',
                  false,
                  '',
                  false,
                  0,
                  20,
                  false,
                  Number(relatedRecord?.Value ?? "0"),
                  '',
                  this.getRestrictChoices(col)
                ),
                getFormOperations,
                this.defaultExtra
              ).then((data) => {
                var dropdown = data?.payload?.find((item: any) => item.Value === relatedRecord?.Value);
                if (!!dropdown) {
                  this.columnDataList[col.FieldKey] = [{ label:dropdown.Name,value:dropdown.Value}];
                  this.fieldIdToGroup(col.FieldKey)?.controls?.RelatedFieldValue?.setValue(dropdown.Name);
                }
              });
              promises.push(promise);
            }
          }
        });
      });
      this.isColumnDropdownValueUpdated = true;
      await Promise.all(promises);
    }
  }

  getFieldName = (fieldKey: string) => {
    if (!!this.savedFields) {
      for (let tab of this.savedFields.TabData) {
        for (let col of tab.Columns) {
          if (col.FieldKey === fieldKey) {
            return col.FieldName;
          }
        }
      }
    }
    return '';
  }

  isDifferentFile(col:any){
    return Array.isArray(this.applicationTableAllFields) && this.applicationTableAllFields?.find(field => field.Key === col.FieldKey)?.Value !== this.formGroupAt(col)?.controls?.Value?.value
  }

  getRestrictChoices(col:Column) {
    if(col?.FormFieldSetting?.RestrictChoices && col?.FormFieldSetting?.ConditionGroup?.find((group) => group.AppliedOn === 'restrict')){
      const conditionGroup = col.FormFieldSetting.ConditionGroup.find((group) => group.AppliedOn === 'restrict');
      return {
        ConditionType: conditionGroup?.ConditionType,
        Conditions: conditionGroup?.Conditions,
      }
    } else {
      return null
    }
  }

  binaryStringToBlob(binaryString:any) {
    const byteArray = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
        byteArray[i] = binaryString.charCodeAt(i);
    }
    return new Blob([byteArray]);
  }

  saveFiles(id:any){
    this.fileFields.forEach((field:any)=>{
      const fileName = localStorage.getItem(`${this.relatedTableKey}_${field}_name`)
      const file = localStorage.getItem(`${this.relatedTableKey}_${field}_file`);
      let fileValue;
      if(file){
        fileValue = this.binaryStringToBlob(file);
        let formData = new FormData();
        formData.append('fn', fileName || '');
        formData.append('data', fileValue);
        formData.append('tid', this.relatedTableKey);
        formData.append('fid', field);
        formData.append('rid', this.recordId);
        this.subscribers.add(
        this.docEditorService
        .saveDoc(formData)
        .subscribe((res: any) => {
          if(res?.fieldsUpdated.length > 0){
            this.alert.toast(
              ToastTypes.SUCCESS,
              'Saved!',
              ''
            );
          }
      }));
      }
    })
  }

  saveTemplates(){
    this.templateFiles.forEach((field:any)=> {
      const fileObject = localStorage.getItem(`${this.relatedTableKey}_${field}_file`);
      if(fileObject){
        const payload = JSON.parse(fileObject);
        payload['RecordId'] = this.recordId;
        this.formService.selectTemplate(payload).subscribe(()=> {})
      }
    })
  }

  isMatchRecordAllowed(reportKey: string) {
    const report = this.reportDetails?.DetailsRelation?.find(
      (relation:any) => relation.EmbeddedSetting?.MatchRecordsReportKey === reportKey
    )
    if(report && Object.keys(this.reports).includes(report.ReportKey)){
      return !this.reports[report.ReportKey].ShowRelatedRecords
    }
    return report && !this.relationTabs?.find((tab:any) => tab.TableKey === report?.TableKey)?.ShowRelatedRecords
  }

  isMatchRelatedRecordAllowed(reportKey: string) {
    const report = this.reportDetails?.DetailsRelation?.find(
      (relation:any) => relation.ReportKey === reportKey
    )
    if(report && Object.keys(this.reports).includes(report.ReportKey)){
      return !this.reports[report.ReportKey].ShowRelatedRecords
    }
    return report && !this.relationTabs?.find((tab:any) => tab.TableKey === report?.TableKey)?.ShowRelatedRecords
  }

  detectLocalFormats(): void {
    const dateFormatter = new Intl.DateTimeFormat(undefined, {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    });

    const datetimeFormatter = new Intl.DateTimeFormat(undefined, {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: 'numeric',
      minute: 'numeric',
    });

    // Detect date format
    this.localDateFormat = this.extractFormat(dateFormatter.formatToParts(new Date()));

    // Detect datetime format
    const datetimeParts = datetimeFormatter.formatToParts(new Date());
    this.localDatetimeFormat = this.extractFormat(datetimeParts);
  }

  // Extracts format from Intl.DateTimeFormat parts
  extractFormat(parts: Intl.DateTimeFormatPart[]): string {
    return parts
      .map((part) => {
        switch (part.type) {
          case 'day':
            return 'DD';
          case 'month':
            return 'MM';
          case 'year':
            return 'YYYY';
          case 'hour':
            return 'hh'; // Use 'hh' for 12-hour format
          case 'minute':
            return 'mm';
          case 'second':
            return 'ss';
          case 'dayPeriod':
            return 'A'; // AM/PM
          default:
            return part.value; // Include separators like '/', ':' etc.
        }
      })
      .join('');
  }

  async loadDetailRelations() {
    try {
      await this.action.dispatch(
        OpTypes.LOAD,
        new LoadDetails(
          this.isInModal ? this.relatedTableKey : this.route.getTableKey(),
          this.isInModal ? this.embeddedReportKey : this.reportId,
          this.isInModal ? this.recordId : this.id,
          this.summaryfieldId ?? null,
          true,
          this.processFormKey || null,
          this.isInProcess
        ),
        getReportOperations
      );
    } catch {
      this.route.navigate([
        '/apps',
        `${this.route.getApplicationKey()}`,
        'tables',
        `${this.relatedTableKey}`,
        'reports',
        'datatable',
        'view',
        this.reportId,
      ]);
    }
  }

}
